if(!Array.prototype.includes){Object.defineProperty(Array.prototype,"includes",{value:function(searchElement,fromIndex){if(this==null){throw new TypeError('"this" is null or not defined')}var o=Object(this);var len=o.length>>>0;if(len===0){return false}var n=fromIndex|0;var k=Math.max(n>=0?n:len-Math.abs(n),0);function sameValueZero(x,y){return x===y||typeof x==="number"&&typeof y==="number"&&isNaN(x)&&isNaN(y)}while(k<len){if(sameValueZero(o[k],searchElement)){return true}k++}return false}})}

window.slate = window.slate || {};
window.theme = window.theme || {};
window.shopify = window.shopify || {};
window.modules = window.modules || {};
window.osvm = window.osvm || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

/**
   * Creates a cookie on the client
   *
   * @param {string} name - Name of the cookie
   * @param {string} value - Value to store in the cookie
   * @param {number} days - Number of days the cookie is valid for
   */
  createCookie: function (name, value, days) {
    var expires;
    if (days) 
    {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    }
    else 
    {
        expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  },

  /**
   * Reads a cookie on the client
   *
   * @param {string} name - Name of the cookie
   */
  readCookie: function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1,c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length,c.length);
        }
    }
    return null;
  },
  

  isValidEmail: function(emailValue) {
    var pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\ ".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (pattern.test(emailValue))
        return true;
    else
        return false;
  },

  camelize: function(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
      if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
      return index == 0 ? match.toLowerCase() : match.toUpperCase();
    });
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    preOrder: '[data-preorder=true]',
    preOrderShipDate: '[data-preorder-date]',
    preOrderEnabled: '[data-preorder-enabled]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    originalBundleSelectorId: '[data-product-bundle-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    magicZoom: 'product-image-zoom',
    quantityDropdown: '#product-quantity-dropdown',
    productVariantDropdown: '.product-variant-dropdown',
    productVariantTwoDropdown: '.product-variant-two-dropdown',
    productLowInventory: '.product-low-inventory',
    productFeaturedImage: '[data-product-featured-image]',
    productVideoZoomGallery: '[data-product-video-zoom-gallery]',
    productVideoiFrame: '.active iframe[src*="youtube"],.active iframe[src*="vimeo"]',
    productThumb: '[data-thumb]',
    thumbnailSlider: '.thumbnail-slider',
    zoomArrowLeft: '.zoom-gallery-arrow-left',
    zoomArrowRight: '.zoom-gallery-arrow-right',
    slickTrack: '.product-image-gallery .slick-track a',
    zoomGalleryArrow: '.zoom-gallery-arrow',
    compareIcon: '.compare-icon',
    compareInfo: 'data-compare-info'
  };

  var elements = {
    addToCart: document.querySelector(selectors.addToCart),
    $addToCart: $(selectors.addToCart),
    $addToCartText: $(selectors.addToCartText),
    $form: $(selectors.addToCart).closest("form"),
    $preorderModalContinueButton: $("[data-preorder-modal-continue-button]")
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson).html());


    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateProductOptionValues.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateProductLowInventory.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    this.$container.on('click', selectors.compareIcon, this.compareIcon.bind(this));

    this.$container.on('click', selectors.addToCart, this.addToCart.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    //Call Product media funtions
    this.displayThumbnailSlider();
    this.displayProductVideoOnClickEvent();

    this.updateBundleLowInventory();

    //Create select2 dropdowns
    createSelect2Dropdown = this.createSelect2Dropdown.bind(this);
    createSelect2Dropdown(selectors.quantityDropdown);
    createSelect2Dropdown(selectors.productVariantDropdown);
    createSelect2Dropdown(selectors.productVariantTwoDropdown);

    //load the yotpo script to add reviews to the page (if enabled)
    if (theme.Yotpo) {
      theme.Yotpo.load();
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        if ($(selectors.preOrder).length > 0) {
          $(selectors.addToCartText, this.$container).html(theme.strings.preOrder);
        }
        else {
          $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        }

      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image id
     *
     * @param {string} id - Image src id
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var $variantFeaturedImage = $('#' + variant.featured_image.id)[0];

      MagicZoom.switchTo(selectors.magicZoom, $variantFeaturedImage);
    },

    /**
     * Updates the DOM with the selected variant option values
     *
     * @param {string} options - Product option values
     */
    updateProductOptionValues: function(evt) {
      var variant = evt.variant;

      for (i = 0; i < 3; i++) {
        if (variant && variant.options != 'undefined' && i < variant.options.length) {
          $('[data-product-option-value-' + i + ']').html(variant.options[i])
        }
      }
    },

    addToCart: function (event) {

      var variant = this.variants.currentVariant;
      var variantId = variant.id;
      var product = this.variants.product;
      var quantity = $(selectors.quantityDropdown, this.$container).val();
      var item = this.getItemData(product, variant);
      var preorderShipDate = $(selectors.preOrderShipDate).data('preorder-date') || "";
      var options = {};

      var preorderEnabled = $(selectors.preOrderEnabled).length > 0;
      var preorderButton = $(selectors.preOrder).length > 0;
      var cartCount = $("body").data("cart").item_count;
      var cartEmpty = cartCount == 0;
      var oneItemInCart = cartCount == 1;
      var cartHasPreorder = false;
      var cartHasSamePreorder = false;

      if ( preorderEnabled ) {
        if ( preorderButton && cartEmpty ) {
          elements.$form.submit();
          return true;
        }

        $.ajax({
          url: "/cart",
          async: false,
          dataType: "json",
          success: function (cart) {
            cart.items.forEach(function (item) {
              if ( item.properties.preorderShipDate ) {
                cartHasPreorder = true;
              }

              if ( item.variant_id == variantId ) {
                cartHasSamePreorder = true;
              }

              theme.minicart.slideout();
            });
          }
        });

        if ( preorderButton && oneItemInCart && cartHasSamePreorder ) {
          elements.$form.submit();
          return true;
        }

        if ( preorderButton || cartHasPreorder ) {
          event.preventDefault();
          theme.preorderModal.show(variantId, quantity, preorderShipDate);
          return;
        }
      }

      // $addToCart.prop('disabled', true);
      // $addToCartText.html(theme.strings.addingToCart);

      event.preventDefault();

      options.success = function() {
        // $addToCart.prop('disabled', false);
        // $addToCartText.html(theme.strings.addToCart);
        modules.tealium.addToCart(item, quantity);
        theme.minicart.slideout();
      };

      options.error = function() {
        $('[data-add-to-cart-text]').text(theme.strings.unavailable);
        $('[data-add-to-cart]').prop('disabled', true);
      }

      var properties = {};

      var result = shopify.cart.addItem(variantId, quantity, properties, options);

      return result;
    },

    bindAndShowPreorderModal: function () {
      var self = this;

      elements.$preorderModalContinueButton.on("click", function () {
        theme.preorderModal.hide();
        shopify.cart.clearCart(function () {
          self.addToCart.call(self);
        });
      });

      theme.preorderModal.show();
    },

    getItemData: function(product, variant) {
      var item = {
        "id": product.id,
        "title": product.title,
        "sku": variant.sku,
        "price": variant.price,
        "compare_at_price": variant.compare_at_price,
        "option1": variant.option1,
        "option2": variant.option2,
        "barcode": variant.barcode
      };

      return item;
    },

    compareIcon: function(e) {
      e.preventDefault();
      var productHandle = $(selectors.compareIcon, this.$container).attr(selectors.compareInfo);
      theme.CompareModal.addCompareProduct( productHandle );
    },

    /**
     * Updates the low inventory snippet based on the variant selected
     *
     * @param {string} options - Product option values
     */
    updateProductLowInventory: function(evt) {
      var $productLowInventory = $('.product-low-inventory');
      var $productInventoryNum = $('.product-inventory-num');
      var lowInventoryThreshold = Number($productLowInventory.attr('data-low-inventory-threshold'));
      var variant = evt.variant;
      var inventoryQuantity = variant && variant.inventory_quantity;

      $productLowInventory.removeClass('product-low-inventory-show');
      variant && $productInventoryNum.text(inventoryQuantity);

      if(variant && inventoryQuantity <= lowInventoryThreshold && inventoryQuantity > 0) {
        $productLowInventory.addClass('product-low-inventory-show');
      }
    },

    /**
     * Sets bundle low inventory
     *
     * @param {string} options - Product option values
     */
    updateBundleLowInventory: function() {
      var $productLowInventory = $('.product-low-inventory');
      var $productInventoryNum = $('.product-inventory-num');
      var $bundleInventoryNum = $('[data-bundle-quantity]');
      var lowInventoryThreshold = Number($productLowInventory.attr('data-low-inventory-threshold')); //threshold
      var bundleQuantity = $bundleInventoryNum.data('bundle-quantity');

      $productLowInventory.removeClass('product-low-inventory-show');
      bundleQuantity && $productInventoryNum.text(bundleQuantity)

      if(bundleQuantity && bundleQuantity <= lowInventoryThreshold) {
        $productLowInventory.show().addClass('force-show');
      }
      if(bundleQuantity && bundleQuantity > lowInventoryThreshold) {
        $productLowInventory.hide().removeClass('force-show');
      }
    },

    /**
     * Binds the thumbnail click event to display the video function
     */

    displayThumbnailSlider: function(arrowPrev, arrowNext) {
      var horizontalSlider = $(selectors.thumbnailSlider).hasClass('slick-horizontal');
      var arrowPrev = horizontalSlider ? 'left' : 'up';
      var arrowNext = horizontalSlider ? 'right' : 'down';
      var $featuredImage = $(selectors.productFeaturedImage, this.$container);

      if ($featuredImage.length > 0) {
          try {
              // featured image loaded
            }
            catch (e) {
              console.log(e);
            }
      };

      $(selectors.thumbnailSlider, this.$container)
          .not('.slick-initialized')
          .slick({
                  prevArrow: '<i class="fa fa-chevron-' + arrowPrev + ' slick-arrow-prev"></i>',
                  nextArrow: '<i class="fa fa-chevron-' + arrowNext + ' slick-arrow-next"></i>'
              });

      // If there is no slick track present hide the zoom gallery slider arrows that show on mobile.
      !$(selectors.slickTrack).length && $(selectors.zoomGalleryArrow).addClass('hide');
    },

    displayProductVideoOnClickEvent: function() {
      $(selectors.productThumb).on('click', function(e) {
          var iframe = $(selectors.productVideoiFrame, self.$container);
          if (iframe.length) {
              iframe.attr('src', iframe.attr('src'));
          }
          self.zoomGallerySlider = $(selectors.productVideoZoomGallery, self.$container);

          self.zoomGallerySlider.removeClass('active');
          $('.product-image-gallery .selectors a').removeClass('active');
          $('.product-image-gallery .zoom-gallery-slide[data-slide-id="' + $(this).attr('data-slide-id') + '"]').addClass('active');
          $(this).addClass('active');
          e.preventDefault();
      });
    },

    onBlockSelect: function() {
        this.$container.unslick().slick();
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
      try {
        // unload success
      }
      catch (e) {
        console.log(e);
      }
    },

    /**
     * Creates select2 dropdowns
     */
    createSelect2Dropdown: function(dropdownSelector) {
      this.$dropdown = $(dropdownSelector);

      if(!this.$dropdown.length) {
        return;
      }

      this.$dropdown.select2({
        minimumResultsForSearch: Infinity
      });

      this.$dropdown.change(function (e) {

        if ( $('[data-add-to-cart-text]').text().trim() != theme.strings.soldOut)
        {
          if ($(selectors.preOrder).length > 0) {
            $('[data-add-to-cart-text]').text(theme.strings.preOrder);
          }
          else {
            $('[data-add-to-cart-text]').text(theme.strings.addToCart);
          }
          $('[data-add-to-cart]').prop('disabled', false);
          $('[data-add-bundle-to-cart]').prop('disabled', false);
          this.updateBundleLowInventory;
        }
      })
    }

  });

  return Product;
})();

// const slider = document.querySelector('.product-media-slider');
// let isDown = false;
// let startX;
// let scrollLeft;

// slider.addEventListener('mousedown', e => {
//   isDown = true;
//   slider.classList.add('active');
//   startX = e.pageX - slider.offsetLeft;
//   scrollLeft = slider.scrollLeft;
// });
// slider.addEventListener('mouseleave', _ => {
//   isDown = false;
//   slider.classList.remove('active');
// });
// slider.addEventListener('mouseup', _ => {
//   isDown = false;
//   slider.classList.remove('active');
// });
// slider.addEventListener('mousemove', e => {
//   if (!isDown) return;
//   e.preventDefault();
//   const x = e.pageX - slider.offsetLeft;
//   const SCROLL_SPEED = 3;
//   const walk = (x - startX) * SCROLL_SPEED;
//   slider.scrollLeft = scrollLeft - walk;
// });

var scrollToLocation = function(triggerSelector, locationSelector, duration = 200, complete) {
  const trigger = $(triggerSelector);
  if (!trigger.length) return;

  trigger.on("click", function (e) {
    e.preventDefault();

    const scrollTop = document
      .querySelector(locationSelector)
      .getBoundingClientRect()
      .top;

    $("html, body").animate(
      {
        scrollTop,
        complete,
      },
      duration,
      "linear"
    );
  });
};

$(document).on('ready', function() {
  scrollToLocation('.pdp-stars-top', '#product-reviews');
});
/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Modal template.
 *
   * @namespace cart
 */

theme.Cart = (function() {
    var selectors = {
        removeCartItem: '[data-remove-cart-item]',
        updateCartItem: '[data-update-cart-item]',
        cartJson: '[data-cart-json]'     
    };

    function Cart(container) {
        this.$container = $(container);
        this.cartObject = JSON.parse($(selectors.cartJson, this.$container).html());
        this.init();
        this.namespace = '.cart';
        theme.cartVM = new osvm.cart();
    }

   Cart.prototype = $.extend({}, Cart.prototype, { 
    init: function() {
      var self = this;
      $(selectors.removeCartItem).on("click", function(e){
        setTimeout(function () {
          window.location.reload(); //reload page
       }, 500);        
        
        var variantURL = $(this).data('item-url');
        var variantId = Number( ( RegExp( 'variant=(.+?)(&|$)' ).exec( variantURL ) || [,null] )[1] );

        theme.cartVM.removeItem(variantId);
      });
    },
      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function() {
        this.$container.off(this.namespace);
      },
      onSelect: function(e,x) {
      }
    });

   return Cart;
})();



/**
 * Slideshow Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Slideshow template.
 *
   * @namespace slideshow
 */

theme.Slideshow = (function() {
    
      var selectors = {
      };
    
      /**
       * Product section constructor. Runs on page load as well as Theme Editor
       * `section:load` events.
       * @param {string} container - selector for the section container DOM element
       */
      function Slideshow(container) {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');
        this.$container.slick();
        this.namespace = '.slideshow';
      }
    
      Slideshow.prototype = $.extend({}, Slideshow.prototype, {
        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onBlockSelect: function() {
    
          this.$container.unslick().slick();
        },    
        onUnload: function() {
          this.$container.off(this.namespace);
        }
      });
    
      return Slideshow;
    })();
    
/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product Media section.
 *
   * @namespace headerTopBar
 */

theme.HeaderTopBar = (function() {

  var selectors = {
    miniCart: "[data-cart-mini]",
    miniCartTrigger: "[data-cart-mini-trigger]",
    miniCartOverlay: "[data-cart-mini-overlay]",
    cartItemQuantity: "[data-variant-quantity]",
    updateItem: "[data-update-quantity]",
    removeItem: "[data-remove-cart-item]",
    subtotal: "[data-subtotal]",
    cartItemPrefix: "#cart-item-",
    searchTrigger: "[data-search-trigger]",
    searchFormContainer: "[data-search-form]",
    searchInput: "[data-search-input]",
    closeSearch: "[data-close-search]"
   };

  /**
   * Cart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function HeaderTopBar(container) {
    this.$container = $(container);
    this.namespace = '.headerTopBar';

  // generic slickjs initializer for slick sliders set slick options inline
    $("[data-slick]").not('.slick-initialized').slick();
    this.bindCartTriggerEvent();
    this.bindSearchTriggerEvent();
    this.bindCloseSearchEvent();
  }

  HeaderTopBar.prototype = $.extend({}, HeaderTopBar.prototype, {
    bindCartTriggerEvent: function() {
      var self = this;
      $(selectors.miniCartTrigger).each(function () {
        $(this).on('click', function (evt) {
          if (self.checkMiniCartClicked()) {
            return;
          }
          evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
          var $miniCart = $(selectors.miniCart);
          var $miniCartOverlay = $(selectors.miniCartOverlay);

          $('body').toggleClass('no-scroll');

          if ($miniCart.hasClass("hide")) {
              $miniCartOverlay.removeClass("hide-overlay");
              $miniCart.removeClass("hide").addClass("fadeInRight");
          }
          else {
            $miniCart.toggleClass("fadeInRight fadeOutRight").delay(500).queue(function(next) {
              $(this).removeClass("fadeOutRight").addClass("hide");
              $miniCartOverlay.addClass("hide-overlay");
              next();
            });
          }
        });
      });
    },

    checkMiniCartClicked: function() {
      var $miniCart = $(selectors.miniCart);
        if ($miniCart.data('clicked')) {
          return true;
        }

        $miniCart.data('clicked', true);
        window.setTimeout(function() {
          $miniCart.removeData('clicked');
        }, 1000);

        return false;
    },

    bindSearchTriggerEvent: function() {
      $(selectors.searchTrigger, this.$container).each(function() {
        $(this).on('click', function(evt){
          evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
          if($(selectors.searchFormContainer).is(":hidden")) {
            $(selectors.searchFormContainer, this.$container).removeClass("hide").addClass("fadeIn").delay(250).queue(function(next) {
              $('input#search.search-input').focus();
              next();
            });
          }
          else {
            $(selectors.searchFormContainer, this.$container).removeClass("fadeIn").addClass("fadeOut").delay(250).queue(function(next) {
              $(this).removeClass("fadeOut").addClass("hide");
              next();
            });
          }
        });
      });
    },

    bindCloseSearchEvent: function() {
      $(selectors.closeSearch, this.$container).each(function(){
        $(this).on('click', function(evt) {
          evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
          $(selectors.searchFormContainer, this.$container).removeClass("fadeIn").addClass("fadeOut").delay(250).queue(function(next) {
            $(this).removeClass("fadeOut").addClass("hide");
            next();
          });
        });
      });
    },

    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return HeaderTopBar;
})();

/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Header section.
 *
   * @namespace header
 */

theme.Header = (function() {

  var selectors = {
    miniCart: "[data-cart-mini]",
    miniCartTrigger: "[data-cart-mini-trigger]",
    miniCartOverlay: "[data-cart-mini-overlay]",
    cartItemQuantity: "[data-variant-quantity]",
    updateItem: ".cart-mini .quantity-btn",
    removeItem: ".cart-mini .cart-mini-remove-item",
    subtotal: "[data-subtotal]",
    cartItemPrefix: "#cart-item-",
    mobileNavTrigger: "[data-mobile-nav-trigger]",
    closeMobileNav: "[data-close-mobile-nav]",
    closeMobileNavLinks: "[data-close-mobile-nav-link]",
    navigation: "[data-mobile-nav-container]",
    mobileNavItems: ".mobile-nav-container .site-nav > li.site-nav--has-submenu",
    subMenuContainerParent: ".site-nav > li",
    subMenuContainer: "[data-submenu-container]",
    desktopSearchTrigger: "[data-search-trigger]",
    desktopSearchFormContainer: "[data-search-form]",
    desktopSearchInput: "[data-search-input]",
    desktopCloseSearch: "[data-close-search]",
    mobileSearchTrigger: "[data-mobile-search-trigger]",
    mobileSearchFormContainer: "[data-mobile-search-form]",
    closeMobileSearch: "[data-close-mobile-search]",
    mobileFooterSubMenuLink: ".mobile-footer-nav .site-nav--has-submenu .site-nav--submenu-container ul li a"
   };

  /**
   * Cart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Header(container) {
    this.$container = $(container);
    this.namespace = '.header';
    theme.cartVM = new osvm.cart();

    this.bindUpdateCartItemEvent();
    this.bindRemoveCartItemEvent();
    this.bindMobileNavEvent();
    this.bindMobileSearchTriggerEvent();
    this.bindMobileCloseSearchEvent();
    this.bindNavHoverEvent();
    this.bindResetSlideInsEvent();
    this.bindDesktopSearchTriggerEvent();
    this.bindDesktopCloseSearchEvent();
  }

  Header.prototype = $.extend({}, Header.prototype, {
    /**
     * Binds the quantity input to the update cart function
     */
    bindUpdateCartItemEvent: function() {
      $("body").on("click", selectors.updateItem, function (evt) {
        var $this = $(this);
        var variantId = $this.data('variant-id');
        var $quantityHolder = $('[data-variant-id=' + variantId + ']' + selectors.cartItemQuantity);
        var quantity = parseInt($quantityHolder.html());

        if (quantity === "NaN")
          return;

        var newQuantity = quantity;
        if ($this.data("update-quantity") === "increment")
          newQuantity += 1;
        else if ($this.data("update-quantity") === "decrement" && quantity > 1)
          newQuantity -= 1;
        else
          return;

        $quantityHolder.html(" " + newQuantity);

        var properties = {};
        var options = {};

        options.error = function() {
          $quantityHolder.html(" " + quantity);
        }

        var result = shopify.cart.updateCart(variantId, newQuantity);
      })
    },

    bindRemoveCartItemEvent: function() {
      $("body").on('click', selectors.removeItem, function (evt) {
        evt.preventDefault();

        var variantId = $(this).data('variant-id');
        var options = {};

        options.success = function () {
          theme.cartVM.removeItem(variantId);
        }

        var result = shopify.cart.updateCart(variantId, 0, options);
      });
    },

    bindMobileNavEvent: function() {
      var $navigation = $(selectors.navigation);

      $(selectors.mobileNavTrigger, this.$container).each(function () {
        $(this).on('click', function (evt) {
          evt.preventDefault();

          $('body').toggleClass('no-scroll');
          if ($navigation.is(":hidden")) {
            $navigation.removeClass("hide").addClass("fadeInLeft");

            var $miniCartOverlay = $(selectors.miniCartOverlay);

            if ($miniCartOverlay.length > 0 )
              $miniCartOverlay.removeClass("hide-overlay");
          }
        });
      });

      $(selectors.closeMobileNavLinks, this.$container).each(function () {
        $(this).on('click', function (evt) {
          $('body').toggleClass('no-scroll');
          closeMobileNav();
          $('.child-heading, .nav-heading, .mobile-links-container, .mobile-link-panel, .nav-heading-link ').removeClass('active');
        });
      });

      $(selectors.closeMobileNav, this.$container).each(function () {
        $(this).on('click', function (evt) {
          evt.preventDefault();
          $('body').toggleClass('no-scroll');
          closeMobileNav();

          // close search input if open
          $(selectors.mobileSearchFormContainer, this.$container).removeClass("slideInDown").addClass("slideOutUp").delay(1000).queue(function(next) {
            $(this).removeClass("slideOutUp").addClass("hide");
            next();
          });
        });
      });

      $(selectors.mobileFooterSubMenuLink).each(function () {
        $(this).on('click', function () {
          $('body').toggleClass('no-scroll');
          closeMobileNav();
          $('.site-nav--has-submenu').removeClass('mobile-expand');
          $('.site-nav--submenu-container').removeClass("animated fadeIn").hide();
        });
      });

      function closeMobileNav() {
        if ($navigation.is(":visible")) {
          $navigation.toggleClass("fadeInLeft fadeOutLeft").delay(500).removeClass("fadeOutLeft").addClass("hide");
          var $miniCartOverlay = $(selectors.miniCartOverlay);
          if ($miniCartOverlay.length > 0 ) {
            $miniCartOverlay.addClass("hide-overlay");
          }
        }
      };

      //bind the mobile nav click expansion
      $(selectors.mobileNavItems, this.$container).each(function () {
        var self = this;
        var touchmoved = false;
        $("> a", this).on('touchend click', function (evt) {
          if(touchmoved != true){
            evt.preventDefault();


            $(self).toggleClass("mobile-expand");

            $(".mobile-caret", self).toggleClass("fa-chevron-down").toggleClass("fa-chevron-right");

            if($(self).hasClass("mobile-expand")) {
              $(self).find("div").addClass("animated").addClass("fadeIn").show();
            }
            else {
              $(self).find("div").removeClass("animated fadeIn").hide();
            }
          }
        }).on('touchmove', function(){
          touchmoved = true;
        }).on('touchstart', function(){
          touchmoved = false;
        });
      });
    },

    bindCartTriggerEvent: function() {
      var self = this;
      $(selectors.miniCartTrigger).each(function () {
        $(this).on('click', function (evt) {
          evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
          var $miniCart = $(selectors.miniCart);

          if (self.checkMiniCartClicked()) {
            return;
          }

          $('body').toggleClass('no-scroll');

          if ($miniCart.hasClass("hide")) {
              $miniCart.removeClass("hide").addClass("fadeInRight");
          }
          else {
            $miniCart.toggleClass("fadeInRight fadeOutRight").delay(500).queue(function(next) {
              $(this).removeClass("fadeOutRight").addClass("hide");
              next();
            });
          }
        })
      });
    },

    checkMiniCartClicked: function() {
      var $miniCart = $(selectors.miniCart);
        if ($miniCart.data('clicked')) {
          return true;
        }

        $miniCart.data('clicked', true);
        window.setTimeout(function() {
          $miniCart.removeData('clicked');
        }, 1000);

        return false;
    },

    bindResetSlideInsEvent: function() {
      var $miniCartOverlay = $(selectors.miniCartOverlay);
      var $miniCart = $(selectors.miniCart);
      var $navigation = $(selectors.navigation);
      var self = this;

      $miniCartOverlay.on('click', function(evt) {
        if (self.checkMiniCartClicked()) {
          return;
        }

        if (!$miniCart.hasClass("hide")) {
          $('body').toggleClass('no-scroll');
          $miniCart.toggleClass("fadeInRight fadeOutRight").delay(500).queue(function(next) {
            $(this).removeClass("fadeOutRight").addClass("hide");
            next();
          });
        }

        $navigation.addClass("fadeOutLeft").delay(500).queue(function(next) {
          $(this).removeClass("fadeInLeft").removeClass("fadeOutLeft").addClass("hide");
          $('body').removeClass('no-scroll');
          next();
        });

        if ($miniCartOverlay.length > 0 && !$miniCartOverlay.hasClass("hide-overlay")) {
          $miniCartOverlay.addClass("hide-overlay");
        };
      })
    },

    bindMobileSearchTriggerEvent: function() {
      $(selectors.mobileSearchTrigger, this.$container).each(function() {
        $(this).on('click', function(evt) {
          evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
          // search box opens
          dataLayer.push({
            'event': 'search box'
          });
          if($(selectors.mobileSearchFormContainer).is(":hidden")) {
            $(selectors.mobileSearchFormContainer, this.$container).removeClass("hide").addClass("slideInDown");
          }
          else {
            $(selectors.mobileSearchFormContainer, this.$container).removeClass("slideInDown").addClass("slideOutUp").delay(1000).queue(function(next) {
              $(this).removeClass("slideOutUp").addClass("hide");
              next();
            });
          }
        });
      });
    },

    bindMobileCloseSearchEvent: function() {
      $(selectors.closeMobileSearch, this.$container).each(function(){
        $(this).on('click', function(evt) {
          evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
          $(selectors.mobileSearchFormContainer, this.$container).removeClass("slideInDown").addClass("slideOutUp").delay(1000).queue(function(next) {
            $(this).removeClass("slideOutUp").addClass("hide");
            next();
          });
        });
      });
    },

    bindDesktopSearchTriggerEvent: function() {
      $(selectors.desktopSearchTrigger, this.$container).each(function() {
        $(this).on('click', function(evt){
          evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
          // search box opens
          dataLayer.push({
            'event': 'search box'
          });
          if($(selectors.desktopSearchFormContainer).is(":hidden")) {
            $(selectors.desktopSearchFormContainer, this.$container).removeClass("hide").addClass("fadeIn").delay(250).queue(function(next) {
              $('input#search.search-input').focus();
              next();
            });
          }
          else {
            $(selectors.desktopSearchFormContainer, this.$container).removeClass("fadeIn").addClass("fadeOut").delay(250).queue(function(next) {
              $(this).removeClass("fadeOut").addClass("hide");
              next();
            });
          }
        });
      });
    },

    bindDesktopCloseSearchEvent: function() {
      $(selectors.desktopCloseSearch, this.$container).each(function(){
        $(this).on('click', function(evt) {
          evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
          $(selectors.desktopSearchFormContainer, this.$container).removeClass("fadeIn").addClass("fadeOut").delay(250).queue(function(next) {
            $(this).removeClass("fadeOut").addClass("hide");
            next();
          });
        });
      });
    },

    bindNavHoverEvent: function() {
      $(selectors.subMenuContainerParent, this.$container).not(".site-nav--no-submenu").each(function() {
        var $subNavParent = $(this);
        var touchCount = 0;
        var $firstNavChild = $subNavParent.children().first();

        $($firstNavChild).on("touchstart", function(evt) {
          if(touchCount == 0) {
              // Disabled to fix scroll / tap issue on mobile footer nav
              // No resulting issues identified

              // evt.preventDefault();
            }
            else {
              return true;
            }
            touchCount++;
          });

        });
    },

    onUnload: function() {
      this.$container.off(this.namespace);
    }

  });

  return Header;
})();

$(document).ready(function(){
  $('.panel-link').on('click', function() {
    if ($(this).data('linklist') == "header-neat") {
      $('.nav-panel-banner').removeClass('hidden');
      console.log('neat clicked');
    } else {
      $('.nav-panel-banner').addClass('hidden');
    }
  })

  setTimeout(function() {
    if (window.location.href.indexOf("fr.") > -1) {
      $('#header-shop').ready(function(){
          $('#header-shop').append("<a href='/pages/shopping-guide' class='guide-link'>Trouvez les meilleurs casques de gaming grâce à notre guide d'achat ></a>");
      });

      $('#mobile-header-shop').ready(function(){
          $('.mobile-nav-container .mobile-header').append("<nav role='navigation'><ul class='site-nav mobile-header-nav'><a href='/pages/shopping-guide'><span class='nav-heading-link no-children'>TROUVEZ LES MEILLEURS CASQUES DE GAMING<br>GRÂCE À NOTRE GUIDE D'ACHAT > </span></a></ul></nav>");
      });
    } else if (window.location.href.indexOf("it.") > -1) {
        $('#header-shop').ready(function(){
            $('#header-shop').append('<a href="/pages/shopping-guide" class="guide-link">Trova le migliori cuffie da gioco con la nostra guida agli acquisti ></a>');
        });

        $('#mobile-header-shop').ready(function(){
            $('.mobile-nav-container .mobile-header').append('<nav role="navigation"><ul class="site-nav mobile-header-nav"><a href="/pages/shopping-guide"><span class="nav-heading-link no-children">TROVA LE MIGLIORI CUFFIE DA GIOCO<br>CON LA NOSTRA GUIDA AGLI ACQUISTI > </span></a></ul></nav>');
        });
    } else if (window.location.href.indexOf("es.") > -1) {
        $('#header-shop').ready(function(){
            $('#header-shop').append('<a href="/pages/shopping-guide" class="guide-link">Encuentra los mejores auriculares de juego en nuestra guía de compras ></a>');
        });

        $('#mobile-header-shop').ready(function(){
            $('.mobile-nav-container .mobile-header').append('<nav role="navigation"><ul class="site-nav mobile-header-nav"><a href="/pages/shopping-guide"><span class="nav-heading-link no-children">ENCUENTRA LOS MEJORES AURICULARES DE JUEGO<br>EN NUESTRA GUÍA DE COMPRAS > </span></a></ul></nav>');
        });
    } else if (window.location.href.indexOf("de.") > -1) {
        $('#header-shop').ready(function(){
            $('#header-shop').append('<a href="/pages/shopping-guide" class="guide-link">Finde dein ideales headset mit unserem shopping-guide ></a>');
        });

      $('#mobile-header-shop').ready(function(){
          $('.mobile-nav-container .mobile-header').append('<nav role="navigation"><ul class="site-nav mobile-header-nav"><a href="/pages/shopping-guide"><span class="nav-heading-link no-children">FINDE DEIN IDEALES HEADSET<br>MIT UNSEREM SHOPPING-GUIDE > </span></a></ul></nav>');
      });
  } else if (window.location.href.indexOf("nl.") > -1) {
      $('#header-shop').ready(function(){
          $('#header-shop').append('<a href="/pages/shopping-guide" class="guide-link">Vind de beste gamingheadsets met onze winkelgids ></a>');
      });

        $('#mobile-header-shop').ready(function(){
            $('.mobile-nav-container .mobile-header').append('<nav role="navigation"><ul class="site-nav mobile-header-nav"><a href="/pages/shopping-guide"><span class="nav-heading-link no-children">VIND DE BESTE GAMINGHEADSETS<br>MET ONZE WINKELGIDS > </span></a></ul></nav>');
        });
    } else if (window.location.href.indexOf("au.") > -1) {
    } else if (window.location.href.indexOf("nz.") > -1) {
    } else {
    }
  }, 2000);
});

/**
 * OS Tabs Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled to the OS tabs section.
 *
 * @namespace productContent
 */
theme.ProductContent = (function() {

    var selectors = {
        swipeTabsContainer: '[data-swipe-tabs]', //.swipe-tabs
        swipeTabs: '[data-swipe-tab]', //.swipe-tab
        swipeTabsContentContainer: '[data-swipe-tabs-container]', //.swipe-tabs-container
        activeTabClassName: 'active-tab'
    };

    var currentIndex = 0;

    /**
     * Product Media section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function ProductContent(container) {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');
        this.namespace = '.productContent';
        this.init();
        this.handleTabClick();
    }

    ProductContent.prototype = $.extend({}, ProductContent.prototype, {
        init: function() {
            var self = this;

            $(selectors.swipeTabsContainer).on('init', function(event, slick) {
                $(selectors.swipeTabsContentContainer).removeClass('invisible');
                $(selectors.swipeTabsContainer).removeClass('invisible');

                currentIndex = slick.getCurrent();
                $(selectors.swipeTabs).removeClass(selectors.activeTabClassName);
                $(selectors.swipeTabs + '[data-slick-index=' + currentIndex + ']').addClass(selectors.activeTabClassName);
            });

            $(selectors.swipeTabsContainer, self.$container).slick(self.generateTabOptions());
            $(selectors.swipeTabsContentContainer, self.$container).slick(self.generateContentOptions());
        },
        generateTabOptions: function() {
            return { slidesToShow: $(selectors.swipeTabs).length || {}, slidesToScroll: 1, arrows: false, infinite: false, asNavFor: $(selectors.swipeTabsContainer)};
        },
        generateContentOptions: function() {
            return { asNavFor: $(selectors.swipeTabsContentContainer), slidesToShow: 1, slidesToScroll: 1, cssEase: 'linear', arrows: false, infinite: false };
        },
        handleTabClick: function() {
            $(selectors.swipeTabs).on('click', function(event, slick, direction) {
                // gets index of clicked tab
                currentIndex = $(this).data('slick-index');
                $(selectors.swipeTabs).removeClass(selectors.activeTabClassName);
                $(selectors.swipeTabs + '[data-slick-index=' + currentIndex +']').addClass(selectors.activeTabClassName);
            });
        },
        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onBlockSelect: function() {
            this.$container.unslick().slick();
        },
        onUnload: function() {
            this.$container.off(this.namespace);
        }
    });

    return ProductContent;
})();
/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts tightly coupled code to the Collection-top-bar section
 *
   * @namespace collectionTopBarSort
 */

theme.CollectionTopBarSort = (function() {

    var selectors = {
      sortBy: '#sort-by'
    };
  
    /**
     * Collection section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function CollectionTopBarSort(container) {
      this.$container = $(container);
      this.namespace = '.collectionTopBarSort';
      
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        defaultSortBy: this.$container.data('default-sort-by'),
        enableKnockout: this.$container.data('enable-knockout') || false,
      };
  
      this.enableKnockout = options.enableKnockout;
  
      var sortBy = $(selectors.sortBy, this.$container);
      var $sortBy = $(selectors.sortBy);
  
      //set the initial value for sort by dropdown
      if (options.defaultSortBy.length > 0) {
        sortBy.val(options.defaultSortBy);
      }
      //bind the sort by event
      sortBy.on('change', this.changeSortBy.bind(this));

      $sortBy.select2({
        minimumResultsForSearch: Infinity
      });
    }
  
    CollectionTopBarSort.prototype = $.extend({}, CollectionTopBarSort.prototype, {
      /**
       * Event callback for updating the sort by
       */
      changeSortBy: function() {
        if (this.enableKnockout) {
          var sortBy = $(selectors.sortBy, this.$container).val();
          theme.collectionVM.sortBy(sortBy);
        }
        else {
          Shopify.queryParams = {};
          if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
              aKeyValue = aCouples[i].split('=');
              if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
              }
            }
          }
  
          Shopify.queryParams.sort_by = $(selectors.sortBy, this.$container).val();
          location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
        }
      },
      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function() {
        this.$container.off(this.namespace);
      }
    });
  
    return CollectionTopBarSort;
  })();
  
/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts tightly coupled code to the Collection section
 *
   * @namespace collection
 */

theme.Collection = (function() {

  var selectors = {
    filterSection: '.filter-section',
    filterItem: '.filter-checkbox input',
    filterHeader: '.filter-header',
    filterExpand: '.filter-header .mobile-expand i',
    loadedProductsSelector: '.product-collection',
    productCountSelector: '.product-count',
    viewAll: '.collection-view-all'
  };

  /**
   * Collection section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Collection(container) {
    this.$container = $(container);
    this.namespace = '.collection';
    theme.collectionVM = new osvm.collection();
    this.appliedFilters = [];
    this.andFilters = [];
    this.orFilters = [];
    this.platformTags = [];
    this.connectionTags = [];
    this.categoryTags = [];
    this.priceTags = [];

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      enableKnockout: this.$container.data('enable-knockout') || false,
      productsPerPage: this.$container.data('products-per-page') || 0,
      collectionHandle: this.$container.data('collection-handle') || '',
      defaultSortBy: this.$container.data('default-sort-by') || 'manual',
    };

    $(selectors.filterItem).on('click', this.changeFilter.bind(this));
    this.bindMobileFilterEvent();
    if (options.enableKnockout) {
      this.bindCollection(options.productsPerPage, options.collectionHandle, options.defaultSortBy);
      this.initInfiniteScroll(250);
      this.bindViewAll();
    }
    else {
      this.loadComplete();
    }
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    /**
     * Event callback for updating the filter
     */
    changeFilter: function(evt) {
      var filterItem = evt.currentTarget;
      var filterItemValue = filterItem.value;
      var sortType = filterItem.getAttribute('data-sort-type');
      var filterGroup = filterItem.getAttribute('data-filter-group');
      // var indexAnd = this.andFilters.indexOf(filterItemValue);
      // var indexOr = this.orFilters.indexOf(filterItemValue);
      var index = this.appliedFilters.indexOf(filterItem.value);
      var indexPlatform = this.platformTags.indexOf(filterItemValue);
      var indexConnection = this.connectionTags.indexOf(filterItemValue);
      var indexCategory = this.categoryTags.indexOf(filterItemValue);
      var indexPrice = this.priceTags.indexOf(filterItemValue);

      if (filterItem.checked) {
        if (index == -1) {
          this.appliedFilters.push(filterItem.value);
        }

        if ( filterGroup == 'platform' || filterGroup == 'plattform' || filterGroup == 'plataforma') {
          if ( filterItemValue == 'Xbox One' || filterItemValue == 'Xbox 360' || filterItemValue == 'Series X' || filterItemValue == 'PS5' || filterItemValue == 'PS4' || filterItemValue == 'PS3' || filterItemValue == 'switch' || filterItemValue == 'PC' || filterItemValue == 'Xbox ONE' || filterItemValue == 'XBOX 360' ) {
            this.platformTags.push(filterItemValue);
            // console.log(this.platformTags);
          }
        }

        if (filterGroup == 'connection' || filterGroup == 'verbindungsart' || filterGroup == 'connessione' || filterGroup == 'conexión' || filterGroup == 'connexion') {
          if (filterItemValue == 'Wired' || filterItemValue == 'Wireless' || filterItemValue == 'Kabelgebunden' || filterItemValue == 'Kabellos' || filterItemValue == 'Con Cavo' || filterItemValue == 'Senza cavo' || filterItemValue == 'Con cable' || filterItemValue == 'Inalámbricos' || filterItemValue == 'Filaire' || filterItemValue == 'Sans fil') {
            this.connectionTags.push(filterItemValue);
            // console.log(this.connectionTags);
          }
        }

        if (filterGroup == 'category' || filterGroup == 'kategorie' || filterGroup == 'categoria' || filterGroup == 'categoría' || filterGroup == 'catégorie') {
          if (filterItemValue == 'Headsets' || filterItemValue == 'Parts' || filterItemValue == 'Accessories' || filterItemValue == 'Gaming-Headsets' || filterItemValue == 'Zubehöer' || filterItemValue == 'Gear' || filterItemValue == 'Cuffie di gioco' || filterItemValue == 'Accessori' || filterItemValue == 'Offerte' || filterItemValue == 'Auriculares de Juego' || filterItemValue == 'Accesorios' || filterItemValue == 'Oferta' || filterItemValue == 'Casques de Gaming' || filterItemValue == 'Accessoires' || filterItemValue == 'Promotions' || filterItemValue == 'Refurbished' || filterItemValue == 'Sale' || filterItemValue == 'sale') {
            this.categoryTags.push(filterItemValue);
            // console.log(this.categoryTags);
          }
        }

        if ( filterGroup == 'price' || filterGroup == 'preis' || filterGroup == 'precio' || filterGroup == 'prix' || filterGroup == 'prezzo' || filterGroup == 'prijs') {
          if ( filterItemValue == 'Full Priced' || filterItemValue == 'Refurbished' || filterItemValue == 'Sale' || filterItemValue == 'Promotions' || filterItemValue == 'Refurbished' || filterItemValue == 'Sale' || filterItemValue == 'sale' || filterItemValue == 'Offerte' ) {
            this.priceTags.push(filterItemValue);
            // console.log(this.priceTags);
          }
        }
      } else {
        if (index > -1) {
          this.appliedFilters.splice(index, 1);
        }

        if ( filterGroup == 'platform' || filterGroup == 'plattform' || filterGroup == 'plataforma') {
          if ( filterItemValue == 'Xbox One' || filterItemValue == 'Xbox 360' || filterItemValue == 'Series X' || filterItemValue == 'PS5' || filterItemValue == 'PS4' || filterItemValue == 'PS3' || filterItemValue == 'switch' || filterItemValue == 'PC' || filterItemValue == 'Xbox ONE' || filterItemValue == 'XBOX 360' ) {
            if (indexPlatform > -1) {
              this.platformTags.splice(indexPlatform, 1);
            }
            // console.log(this.platformTags);
          }
        }

        if (filterGroup == 'connection' || filterGroup == 'verbindungsart' || filterGroup == 'connessione' || filterGroup == 'conexión' || filterGroup == 'connexion') {
          if (filterItemValue == 'Wired' || filterItemValue == 'Wireless' || filterItemValue == 'Kabelgebunden' || filterItemValue == 'Kabellos' || filterItemValue == 'Con Cavo' || filterItemValue == 'Senza cavo' || filterItemValue == 'Con cable' || filterItemValue == 'Inalámbricos' || filterItemValue == 'Filaire' || filterItemValue == 'Sans fil') {
            if (indexConnection > -1) {
              this.connectionTags.splice(indexConnection, 1);
            }
            // console.log(this.connectionTags);
          }
        }

        if (filterGroup == 'category' || filterGroup == 'kategorie' || filterGroup == 'categoria' || filterGroup == 'categoría' || filterGroup == 'catégorie') {
          if (filterItemValue == 'Headsets' || filterItemValue == 'Parts' || filterItemValue == 'Accessories' || filterItemValue == 'Gaming-Headsets' || filterItemValue == 'Zubehöer' || filterItemValue == 'Gear' || filterItemValue == 'Cuffie di gioco' || filterItemValue == 'Accessori' || filterItemValue == 'Offerte' || filterItemValue == 'Auriculares de Juego' || filterItemValue == 'Accesorios' || filterItemValue == 'Oferta' || filterItemValue == 'Casques de Gaming' || filterItemValue == 'Accessoires') {
            if (indexCategory > -1) {
              this.categoryTags.splice(indexCategory, 1);
            }
            // console.log(this.categoryTags);
          }
        }

          if ( filterGroup == 'price' || filterGroup == 'preis' || filterGroup == 'precio' || filterGroup == 'prix' || filterGroup == 'prezzo' || filterGroup == 'prijs') {
            if ( filterItemValue == 'Full Priced' || filterItemValue == 'Refurbished' || filterItemValue == 'Sale'  || filterItemValue == 'Promotions' || filterItemValue == 'Refurbished' || filterItemValue == 'Sale' || filterItemValue == 'sale' || filterItemValue == 'Offerte' ) {
              if (indexPrice > -1) {
                this.priceTags.splice(indexPrice, 1);
              }
              // console.log(this.priceTags);
            }
          }
        }

      var result = theme.collectionVM.filter(this.appliedFilters, this.platformTags, this.connectionTags, this.categoryTags, this.priceTags);

      try {
        if (typeof weglotInit !== 'undefined') {
          weglotInit();
        }
        if (typeof collectionUpdateReviews !== 'undefined') {
          collectionUpdateReviews();
        }
        if (typeof insertFeaturedCards !== 'undefined') {
          insertFeaturedCards();
        }
      } catch (e) {
        console.log(e);
      }

    },

    bindMobileFilterEvent: function() {
      $(selectors.filterHeader).each(function () {
        $(this).on('click', function (evt) {
          evt.preventDefault();
          $(selectors.filterExpand).toggleClass("fa-plus");
          $(selectors.filterExpand).toggleClass("fa-minus");
          $(selectors.filterSection).toggleClass("expanded");
        })
      });
    },

    bindViewAll: function() {
      $(selectors.viewAll).on('click', function (evt) {
          evt.preventDefault();
          //reset the filter
          theme.collectionVM.viewall();
          //uncheck the filter boxes
          $(selectors.filterItem).each(function() {
            $(this).prop('checked', false);
          })
      });
    },

    bindCollection: function(productsPerPage, collectionHandle, defaultSortBy) {
      //set the products per page on the VM
      var self = this;
      theme.collectionVM.productsPerPage(productsPerPage);
      var pagesToLoad = 1;
      //load the products, starting with the first page
      var result = theme.collectionVM.init(collectionHandle, defaultSortBy, 1, [], [], [], [], []);
      //to avoid conflict inside result.done
      var collection = theme.collectionVM;
      result.done(function () {
        var loadedProductsElement = $(selectors.loadedProductsSelector)[0];
        var productCountElement = $(selectors.productCountSelector)[0];
        if (loadedProductsElement) {
          ko.applyBindings(collection, loadedProductsElement);
        }
        if (productCountElement) {
          ko.applyBindings(collection, productCountElement);
        }
        self.loadComplete();
      });
    },

    loadComplete: function() {
      //anything that needs to be done after the products are loaded should be done here
      if (theme.Yotpo) {
        theme.Yotpo.load();
      }

      try {
        if (typeof weglotInit !== 'undefined') {
          weglotInit();
        }
        if (typeof collectionUpdateReviews !== 'undefined') {
          collectionUpdateReviews();
        }
        if (typeof insertFeaturedCards !== 'undefined') {
          insertFeaturedCards();
        }
      } catch (e) {
        console.log(e);
      }
    },

    loadNextComplete: function() {
      if (theme.Yotpo) {
        theme.Yotpo.reload();
      }
    },

    initInfiniteScroll: function(scrollOffset) {
      var self = this;
      var getOffsetTop = function (element) {
          var offsetTop = 0;

          do {
              if (!isNaN(element.offsetTop))
                  offsetTop += element.offsetTop;
          } while (element = element.offsetParent);

          return offsetTop;
      };

      var loadMoreProductsConditionally = function () {
          if (theme.collectionVM.loading())
              return;

          if (!theme.collectionVM.hasMoreProducts())
              return;

          var bottomOfWindow = $(window).height() + $(window).scrollTop();

          var productsListArea = getOffsetTop($(selectors.loadedProductsSelector)[0]) + $(selectors.loadedProductsSelector)[0].offsetHeight;

          if (bottomOfWindow > productsListArea - scrollOffset) {
            var result = theme.collectionVM.loadNextPage();
            result.done(function() {
              self.loadNextComplete();
            });
          }
      };



      var innerInit = function () {
          loadMoreProductsConditionally.call();

          var timer = null;
          $(window).on("scroll", function () {
              clearTimeout(timer);
              timer = setTimeout(loadMoreProductsConditionally, 100);
          });
      };

      if ($.isReady) {
          innerInit.call();
      } else {
          $(document).ready(innerInit);
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Collection;
})();

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts tightly coupled to the Collection Filter Dropdown section
 *
   * @namespace collectionFilterDropdown
 */

 theme.CollectionFilterDropdown = (function() {
    var filter_sections = $('.filter-section').toArray();

    filter_sections.forEach(
        function(filter_section){
            var filter_tags = $(filter_section).find("li");
            if (filter_tags.length == 1) {
                $(filter_section).hide();
            }
        }
    );
 })

var filterSection = document.querySelector('#shopify-section-collection-filter-dropdown');

if (filterSection) {

    var filterButton = document.querySelector('.show-filters-button');
    var filterSection = document.querySelector('#shopify-section-collection-filter-dropdown');
    var filterDropdown = document.querySelector('.collection-filter');
    var filterWrapper = document.querySelector('.filter-wrapper');
    var filterDropdownBlocks = document.querySelector('.filter-blocks');
    var filterCloseButton = document.querySelector('.filter-dropdown-close-button');
    var applyButton = document.querySelector('.filter-apply-button');
    var mobileWidth = window.matchMedia("(max-width: 1024px)");

    window.addEventListener('load', function() {
        if (mobileWidth.matches) {
            filterSection.style.height = window.screen.availHeight + 'px';
            document.getElementById('sort-by').classList.remove('select2-hidden-accessible');
        }
    })

    window.addEventListener('resize', function() {
        if (mobileWidth.matches) {
            filterSection.style.height = window.screen.availHeight + 'px';
            document.getElementById('sort-by').classList.remove('select2-hidden-accessible');
            // only hijack scrolling for filter dropdown when already open and resizing
            // a desktop window
            if (!filterDropdown.classList.contains('hide')) {
                document.body.style.overflow = 'hidden';
                filterWrapper.style.overflow = 'auto';
            }
        } else {
            filterSection.style.height = 'auto';
            document.getElementById('sort-by').classList.add('select2-hidden-accessible');
            document.body.style.overflow = 'scroll';
            filterWrapper.style.overflow = 'hidden';
        }
    })

    function openFilterDropdown() {
        filterDropdown.classList.toggle('hide');
            if (mobileWidth.matches) {
                document.body.style.overflow = 'hidden';
                filterWrapper.style.overflow = 'auto';
            }
    }

    function closeFilterDropdown() {
        filterDropdown.classList.toggle('hide');
            if (mobileWidth.matches) {
                document.body.style.overflow = 'scroll';
                filterWrapper.style.overflow = 'hidden';
            }
    }


    filterButton.addEventListener('click', openFilterDropdown);
    applyButton.addEventListener('click', closeFilterDropdown);
    filterCloseButton.addEventListener('click', closeFilterDropdown);

    // Update count of applied filters on the clear button
    var filterCounter = 0;
    var filterCheckBoxes = document.querySelectorAll('.filter-checkbox input');
    var clearButton = document.querySelector('.filter-clear-button');
    var clearButtonCount = document.querySelector('.clear-button-count');
    
    for (var i = 0; i < filterCheckBoxes.length; i++) {
        filterCheckBoxes[i].addEventListener('click', function() {
            if (this.checked) {
                filterCounter++;
            } else {
                filterCounter--;
            }
            if (filterCounter===0) {
                clearButtonCount.innerText = '';
            } else {
                clearButtonCount.innerText = '(' + filterCounter + ')';
            }
        })
    }

    // Clear filters
    clearButton.addEventListener('click', function() {
        for (var i = 0; i < filterCheckBoxes.length; i++) {
            if (filterCheckBoxes[i].checked) {
                filterCheckBoxes[i].click();
            }
        }
    })

}
/**
 * Content Products Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the content-products template.
 *
   * @namespace contentProducts
 */ 

theme.ContentProducts = (function() {

  var selectors = {
    addToCart: '[data-collection-add-to-cart]',
    preOrder: '[data-preorder=true]',
    preOrderShipDate: '[data-preorder-date]',
    preOrderEnabled: '[date-preorder-enabled]',
    addToCartText: '[data-add-to-cart-text]',
    compareIcon: '.compare-icon',
    compareInfo: 'data-compare-info'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function ContentProducts(container) {
    this.$container = $(container);
    this.namespace = '.contentProducts';
    this.init();
  }
  ContentProducts.prototype = $.extend({}, ContentProducts.prototype, {
    init: function() {
      $(selectors.addToCart).each(function () {
        $(this).on('click', function (event) {
          event.preventDefault();

          var $addToCartButton = $(this);
          var $form = $addToCartButton.closest("form");
          var $productInfo = $addToCartButton.closest(".product-info");

          if (!$form) return;

          var $variant = $form.find('[data-product-select]');

          if (!$variant) return;

          var variantId = $variant.val();
          var quantity = 1;
          var properties = {};
          var options = {};
          var preorderShipDate = $addToCartButton[0].getAttribute('data-preorder-date') || "";
          var preorderButton = $addToCartButton[0].hasAttribute("data-preorder");
          var preorderEnabled = $addToCartButton[0].hasAttribute("data-preorder-enabled");
          var cartEmpty = false;
          var cartHasPreorder = false;
          var cartHasSamePreorder = false;
          var oneItemInCart = false;

          if ( preorderEnabled ) {
            $.ajax({
              url: "/cart",
              async: false,
              dataType: "json",
              success: function (cart) {
                if ( cart.items.length == 0 ) {
                  cartEmpty = true;
                }

                if ( cart.items.length == 1 ) {
                  oneItemInCart = true;
                }

                cart.items.forEach(function (item) {
                  if ( item.properties.preorderShipDate ) {
                    cartHasPreorder = true;
                  }

                  if ( item.variant_id == variantId ) {
                    cartHasSamePreorder = true;
                  }
                });
              }
            });

            if ( preorderButton && cartEmpty ) {
              $form.submit();
              return true;
            }

            if ( preorderButton && oneItemInCart && cartHasSamePreorder ) {
              $form.submit();
              return true;
            }

            if ( preorderButton || cartHasPreorder ) {
              theme.preorderModal.show(variantId, quantity, preorderShipDate);
              return;
            }
          }

          $(selectors.addToCart, $form).prop('disabled', true);
          $(selectors.addToCartText, $form).html(theme.strings.addingToCart);

          var item = {
            "id": $productInfo.data("id"),
            "title": $productInfo.data("title"),
            "sku": $productInfo.data("sku"),
            "price": $productInfo.data("price"),
            "compare_at_price": $productInfo.data("reg-price"),
            "option1": $productInfo.data("option1"),
            "option2": $productInfo.data("option2"),
            "barcode": $productInfo.data("barcode")
          };

          options.error = function() {
            $addToCartButton.text(theme.strings.unavailable);
          }

          options.success = function() {
            $(selectors.addToCart, $form).prop('disabled', false);
            $(selectors.addToCartText, $form).html(theme.strings.addToCart);
            modules.tealium.addToCart(item, quantity);
            theme.minicart.slideout();
          }

          var result = shopify.cart.addItem(variantId, quantity, properties, options);
        });
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }

  });
  return ContentProducts;
})();
// =require sections/content-yotpo.js
/**
 * Product Information Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product Information section.
 *
 * @namespace productInformation
 */

theme.ProductInformation = (function () {
    var selectors = {
        accordionRow: ".accordion-menu .accordion-row-title",
        accordionItems: ".accordion-items",
        accordionCollapsedClass: "accordion-menu-collapse",
        $stickyHeader: $("#product-sticky-header"),
        $stickyHeaderNavWrapper: $("#product-sticky-header .nav-wrapper"),
        $stickyNavLink: $(".product-sticky-header nav a"),
    };
    /**
     * Product Information section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function ProductInformation(container) {
        this.$container = $(container);
        this.namespace = ".productInformation";

        this.detectAccordionItemClickEvent();
        this.scrollToSection();
        this.stickyHeaderHideNullLinks();
        this.stickyHeaderSetToFixed();
    }

    ProductInformation.prototype = $.extend({}, ProductInformation.prototype, {
        /**
         * Binds the accordian row button click event to expand the row
         */
        detectAccordionItemClickEvent: function () {
            $(selectors.accordionRow).on("click", function (e) {
                var $thisSiblings = $(this)
                    .parent()
                    .siblings()
                    .find(selectors.accordionItems);
                var $thisAccordianItems = $(this).parent().find(selectors.accordionItems);
                $thisAccordianItems.slideToggle("slow");

                // Scroll to open accordion
                var $window = $(window),
                    thisTop = $thisAccordianItems.offset().top,
                    thisHeight = $thisAccordianItems.height(),
                    viewportHeight = $window.height(),
                    scrollIt = thisTop - (viewportHeight - thisHeight) / 2;
                $window.scrollTop(scrollIt);

                // @DO - show only one open accordion item at a time
                for (var i = 0; i < $thisSiblings.length; i++) {
                    if ($thisSiblings[i].style.display === "block") {
                        $thisSiblings[i].style.display = "none";
                        $($thisSiblings[i])
                            .parent()
                            .addClass(selectors.accordionCollapsedClass);
                    }
                }

                if ($(this).parent().hasClass(selectors.accordionCollapsedClass)) {
                    $(this).parent().removeClass(selectors.accordionCollapsedClass);
                } else {
                    $(this).parent().addClass(selectors.accordionCollapsedClass);
                }
            });
        },
        /**
         * Binds the stick nav links click event so we can scroll to a section.
         * The href should match the block id the user set at the block level.
         * After the animation to the section we change the focus to that element.
         */
        scrollToSection: function () {
            selectors.$stickyNavLink.on("click", function (e) {
                e.preventDefault();
                var targetId = $(this).attr("href");
                var $target = $(targetId);
                var scrollToOffset =
                    Math.ceil($target.offset().top) -
                    $("#product-sticky-header").height();

                $("html, body").animate(
                    {
                        scrollTop: scrollToOffset,
                    },
                    600,
                    function () {
                        $target.focus();
                        if ($target.is(":focus")) {
                            return false;
                        } else {
                            $target.focus();
                        }
                    }
                );
            });
        },
        /**
         * We hide the links in the sticky nav that do not have sections that match
         * the id they would want the user to scroll to.
         */
        stickyHeaderHideNullLinks: function () {
            if (selectors.$stickyHeader.length) {
                selectors.$stickyNavLink.each(function () {
                    var linkId = $(this).attr("href");
                    var sectionExists = $(linkId).length;

                    if (!sectionExists) {
                        $(this).addClass("hide-object");
                    }
                });
            }
        },
        /**
         * When the user scrolls beyond the relative postion of the sticky header
         * set the the sticky header to a fixed position. When the user scrolls
         * back above the initial position return the sticky header to its
         * relative position. We also set the sticky header div to the same
         * height as the nav element it contains. This height can change if
         * the window shrinks and the links wrap to two lines. Also this prevents
         * the page from jumping when the fixed class is applied to the nav.
         */
        stickyHeaderSetToFixed: function () {
            var $stickyHeader = selectors.$stickyHeader;
            var $stickyHeaderNavWrapper = selectors.$stickyHeaderNavWrapper;

            if ($stickyHeader.length) {
                $(window).scroll(function () {
                    var stickyHeaderOffset = $stickyHeader.offset().top;

                    if ($(this).scrollTop() > stickyHeaderOffset) {
                        $stickyHeaderNavWrapper.addClass("nav-fixed");
                    } else {
                        $stickyHeaderNavWrapper.removeClass("nav-fixed");
                    }

                    if ($stickyHeader.height() !== $stickyHeaderNavWrapper.height()) {
                        $stickyHeader.height($stickyHeaderNavWrapper.height());
                    }
                });
            }
        },
        /**
         * Hide empty accordions
         */
        hideEmptyYotpo: function () {
            if ($('[total-reviews-search]').value == "0") {
                $(this).closest('.product-reviews').hide();
            }
        },
    });
    return ProductInformation;
})();

/**
 * Back to top Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the BackToTop template.
 *
   * @namespace backToTop
 */

theme.BackToTop = (function() {
    
     var selectors = {
        verticalOffset: '[data-vertical-offset]',
        backToTop: '.back-to-top'
    };
  
    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function BackToTop(container) {
      this.$container = $(container);
      var sectionId = this.$container.attr('data-section-id');
      this.namespace = '.backToTop';

      this.initBackToTop();
    }
    BackToTop.prototype = $.extend({}, BackToTop.prototype, {
      initBackToTop: function() {
        var offset = $(selectors.verticalOffset, this.$container).data('vertical-offset');
        var duration = 500;
        var self = this;
        $(window).scroll(function() {
          if ($(this).scrollTop() > offset) {
            $(selectors.backToTop, self.$container).fadeIn(duration);
          } 
          else {
            $(selectors.backToTop, self.$container).fadeOut(duration);
          }
        });
        $(selectors.backToTop, self.$container).unbind('click.smoothscroll').bind('click', function(e) {
          e.preventDefault();
          $('html, body').animate( { scrollTop: 0 }, duration);
          return false; 
        });
      }, 
      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onBlockSelect: function() {
  
      }, 
      onPageScroll: function() {
        
      },
      onUnload: function() {
        this.$container.off(this.namespace);
      }
      
    });
    return BackToTop;
  })();
/**
 * Modal Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Modal template.
 *
   * @namespace modal
 */

theme.NewsletterModal = (function() {
    var selectors = { 
        newsletterModal: "[data-newsletter-modal]",
        cookieExpires: "[data-cookie-expires]",
        trigger: "[data-modal-trigger]",
        closeModal: "[data-close-modal]",
        modalOverlay: "[data-newsletter-overlay]",
        countryName: "[data-country-name]",
        mobileHeader: ".mobile-header"
    };

    /**
     * Slideshow section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function NewsletterModal(container) {
        var self = this;
        this.$container = $(container);
        this.namespace = '.modal';

        this.showModal();
        this.closeModal();
        this.initForm();
        this.initPOSTcheck();

        var newUser = slate.utils.readCookie("newsletter_isreturning");
        var $myDiv = $('#MainContent .homepage');

        if(!newUser && $myDiv.length > 0) {
            $(selectors.trigger).click();
        }
    }
  
    NewsletterModal.prototype = $.extend({}, NewsletterModal.prototype, {

        showModal: function() {
            $(selectors.trigger, this.$container).each(function(){
                $(this).on('click', function (evt) {
                    evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
                    var $newsletterModal = $(selectors.newsletterModal);

                    if($newsletterModal.hasClass("hide")) {
                        $newsletterModal.removeClass("hide").addClass("slideInUp");
                    }
                });
            });
        },

        closeModal: function() {
            $(selectors.closeModal, this.$container).each(function(){
                $(this).on('click', function (evt) { 
                    evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
                    var $newsletterModal = $(selectors.newsletterModal);
                    var newUser = slate.utils.readCookie("newsletter_isreturning");

                    if ($newsletterModal.is(":visible")) {
                        if(!newUser) {
                            slate.utils.createCookie("newsletter_isreturning", "1", 1);
                        }
                        $newsletterModal.toggleClass("slideInUp slideOutDown").delay(1000).queue(function(next) {
                            $(this).removeClass("slideOutDown").addClass("hide");
                            next();           
                        });
                    }
                });
            });
        },
        
        initForm: function() {
            var self = this;
            $(".signup-form > form").on("submit", function(evt) {
                evt.preventDefault()
                var form = this;
                var email = form.elements['contact[email]'].value;
                var $newsletterModal = $(selectors.newsletterModal);
                var mobileDisplay = $(selectors.mobileHeader).css('display').toLowerCase();
                var isMobile = mobileDisplay !== 'none' ? true : false;

                if(slate.utils.isValidEmail(email)) {

                    $(selectors.modalOverlay).removeClass("hide");

                    var sailthruobj = Object.assign({}, theme.SailthruObj);
                    sailthruobj.email = email;
                    sailthruobj.source = "newsletter-slideup";
                    sailthruobj.onSuccess = function() {
                        slate.utils.createCookie("newsletter_isreturning", "1", $(selectors.cookieExpires).data("cookie-expires"));
                        setTimeout(function () {
                            !isMobile && $newsletterModal.removeClass("hide").addClass("slideInUp");
                        }, 3000);
                        form.submit();
                    };
                    sailthruobj.onError = function() {
                        $(selectors.modalOverlay).addClass("hide");
                        alert('We encountered an issue signing you up. Please try again');
                       };

                    Sailthru.integration("userSignUp", sailthruobj);
                }
            })
        },

        initPOSTcheck: function() {
            var customerPosted = '?customer_posted=true';
            var urlSearchParam = window.location.search;
            var mobileDisplay = $(selectors.mobileHeader).css('display').toLowerCase();
            var isMobile = mobileDisplay !== 'none' ? true : false;
            var $newsletterModal = $(selectors.newsletterModal);

            /**
             * If the user successfully submitted a newsletter signup on desktop
             * slide the newsletter modal up.
            */
            if(urlSearchParam.indexOf(customerPosted) !== -1) {
                $newsletterModal.removeClass("hide").addClass("slideInUp");
            }
        }
    });

    return NewsletterModal;
  })();

/**
 * Modal : Cookies Acceptance Warning (EU Compliance)
 * ------------------------------------------------------------------------------
 * This file is tightly-coupled to the modal template structure
 *    @namespace modal
 **/

 theme.CookiesModal = ( function() {

    // UI : Declare UI Targets
    var selectors = {
        cookiesModal: '#cookies-modal-wrapper',
        closeModalButton: '[data-close-cookies-modal]'
    }

    // BASE : Initial instantation of component
    function CookiesModal( container ) {
        this.$container = $( container );
        this.namespace = '.modal';

        this.showModal();
        this.acceptAndCloseModal();
    }


    // EVENTS : Attach Click and showModal Events. 
    // NOTE   : Not rendered if settings.disable_cookies_modal (US)
    CookiesModal.prototype = $.extend( {}, CookiesModal.prototype, {
        showModal: function() {
            var hasAccepted = slate.utils.readCookie( 'accept_cookie_policy' );
            var modal = $( selectors.cookiesModal );
            
            // New User || User wiped accept cookie
            if ( !hasAccepted && modal ) {
                modal.attr( 'data-show-modal', true );
            }
        },

        acceptAndCloseModal: function() {
            var closeBtn = $( selectors.closeModalButton );

            // SAVE + HIDE : Save acceptance of policy and hide modal so it wont appear again.
            if ( closeBtn ) {
                closeBtn.on( 'click', function() {
                    slate.utils.createCookie( 'accept_cookie_policy', 'true', 9999 ); // name, value, #days_to_expire
                    $( selectors.cookiesModal ).attr( 'data-show-modal', false );
                })
            }
        }
    })

    return CookiesModal;
 })();
/**
 * Modal : Back in Stock Modal
 * ------------------------------------------------------------------------------
 * This file is tightly-coupled to the modal template structure
 *    @namespace modal
 **/

 theme.BackInStockModal = ( function() {

  // UI : Declare UI Targets
  var selectors = {
    backinstockModal: '#back-in-stock-modal-wrapper',
    backinstockButton: '[data-back-in-stock-button]',
    closeModalButton: '[data-back-in-stock-modal-close-button]',
    submitModalButton: '.back-in-stock-submit',
    emailInput: '#back-in-stock-email',
  }

  // BASE : Initial instantation of component
  function BackInStockModal( container ) {
    this.$container = $( container );
    this.namespace = '.modal';

    this.showModal();
    this.closeModal();
    this.submitAndCloseModal();

    $(function(){
      $( '.cta-back-in-stock' ).removeClass('hidden');
    })
  }

  // EVENTS : Attach Click and showModal Events.
  BackInStockModal.prototype = $.extend( {}, BackInStockModal.prototype, {
    showModal: function() {
      var modal = $( selectors.backinstockModal );
      var button = $( selectors.backinstockButton );
      var frpButton = $('.frpATC span:contains('+window.theme.strings.notifyMe.toUpperCase()+')').parent();

      // Show modal
      button.on('click', function(e){
        e.preventDefault();
        $('.msg-body').show();
        $('.back-in-stock-input').show();
        $('.back-in-stock-submit').show();
        $('.msg-success').addClass('hidden');
        modal.attr( 'data-show-modal', true );
        $( selectors.closeModalButton ).trigger('focus');
      })

      // Show modal
      frpButton.on('click', function(e){
        e.preventDefault();
        $('.msg-body').show();
        $('.back-in-stock-input').show();
        $('.back-in-stock-submit').show();
        $('.msg-success').addClass('hidden');
        modal.attr( 'data-show-modal', true );
        $( selectors.closeModalButton ).trigger('focus');
      })

      // Trap focus on modal
      modal.on('keydown', function(e){
        let isEscape = (e.key === "Escape" || e.key === "Esc");
        let isTab = (e.key === 'Tab' || e.keyCode === 9);
        let lastFocusedElement = $( selectors.submitModalButton );
        switch(true) {
          case (isEscape):
            if (modal.attr( 'data-show-modal' ) === "true") {
              $( selectors.backinstockModal ).attr( 'data-show-modal', false );
              $( selectors.backinstockButton ).trigger('focus');
            }
            break;
          case (isTab):
            if (modal.attr( 'data-show-modal' ) === "true" && document.activeElement.className === lastFocusedElement.attr('class')) {
              $( selectors.backinstockModal ).trigger('focus');
            }
            break;
          default:
            break;

        }
      })
    },

    closeModal: function() {
      var closeBtn = $( selectors.closeModalButton );

      // Close modal
      if ( closeBtn ) {
        closeBtn.on( 'click', function() {
          $( selectors.backinstockModal ).attr( 'data-show-modal', false );
          $( selectors.backinstockButton ).trigger('focus');
        })
        closeBtn.on( 'tap', function() {
          $( selectors.backinstockModal ).attr( 'data-show-modal', false );
          $( selectors.backinstockButton ).trigger('focus');
        })
        closeBtn.on( 'keypress', function(e) {
          if ((e.key === 'Enter' || e.keyCode === 13) && $( selectors.backinstockModal ).attr( 'data-show-modal') === "true") {
            $( selectors.backinstockModal ).attr( 'data-show-modal', false );
            $( selectors.backinstockButton ).trigger('focus');
          }
        })
      }
    },

    submitAndCloseModal: function() {
      var submitButton = $( selectors.submitModalButton );
      var closeBtn = $( selectors.closeModalButton );

      submitButton.on('click', function(e) {
        e.preventDefault();

        var email = document.getElementById('back-in-stock-email').value;
        var site = window.theme.strings.domain;
        var variant = $(this).attr("data-prod-variant");
        site = site.replace('https://', '');
        email = encodeURIComponent(email);

        var settings = {
          "async": true,
          "crossDomain": true,
          "url": "https://beachify.turtlebeach.com/api/services/klaviyo/catalog-subscribe?shop="+site+"&email=" + email + "&variant=" + variant + "&platform=shopify",
          "method": "POST",
        }

        console.log(settings);

        $.ajax(settings).done(function (response) {
          if (response.data.status == 200) {
            $('.msg-body').hide();
            $('.back-in-stock-input').hide();
            $('.back-in-stock-submit').hide();
            $('.msg-success').removeClass('hidden');
          } else {
            console.log('failure');
          }
        });
      })
    }
  })

  return BackInStockModal;
})();
/**
 * Modal : Compare Feature Modal Controller
 * ------------------------------------------------------------------------- */
var UrlList = [];


theme.CompareModal = {

    // UI : ID=Rendered UI, Button=Data-attr so functionality can shuffle about
    selectors : {
        compareModal: '#compare-modal-parent',
        compareList: '#compare-item-list',
        compareSpecList: '#compare-spec-list',
        compareTab: '#compare-tab',
        compareTabCount: '#compare-tab-count',
        closeModalButton: '[data-compare-close-modal]',
        modalOnScreenFlag: '[data-modal-on-screen]',
        removeProductButton: '[data-compare-remove-item]',
        removeAllProductButton: '[data-compare-remove-all]',
        specLabels: '[data-compare-spec-labels]',
        openFullCompareButton: '[data-compare-open-full]'
    },

    // STATE : UI updates based on state pushed @ renderContent()
    state : {
        addingToCart : false,
        compareList : [],
        panel: 'hidden',
        specLabels: [],
        warning: 'hidden'
    },

    // INIT : Read localStorage + store to component state
    init: function() {
        var getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
        };

        // STATE : SYNC FROM STORAGE : Local state match compare-list localStorage Object
        var newState = {};
        var compareList = JSON.parse( localStorage.getItem( 'compare-list' ) ); //Safe, null if not found
        var preload = getUrlParameter('preload')
        if ( compareList && compareList.length > 0 ) {
            newState = {
                compareList: compareList,
                panel: 'tab'
            }
        }

        // STATE : GRAB SPEC LABELS : Parse and store the spec labels from settings config in data attr
        newState.specLabels = $( this.selectors.specLabels ).attr( 'data-compare-spec-labels' ).split( ',' );
        this.updateState( newState );
        // EVENTS : Attach Event Handlers
        $( this.selectors.closeModalButton ).on( 'click', this.closeModal.bind( this ) );
        $( this.selectors.removeAllProductButton ).on( 'click', this.removeAll.bind( this ) );
        $( this.selectors.openFullCompareButton ).on( 'click', this.expandFullCompare.bind( this ) );
        $( this.selectors.compareTab ).on( 'click', this.expandTab.bind( this ) );
        $( document ).on( 'removeCompareItem', this.removeItem.bind( this ) );
        $( document ).on( 'addCompareItemToCart', this.addToCart.bind( this ) );
    },

    // UI : CLOSE FUNCTIONALITY : Modal Itself (Full & Mini Panel)
    closeModal: function() {
        this.updateState({
            panel: this.state.compareList.length > 0 ? 'tab' : 'hidden'
        });
        if($(document.body).hasClass("compare-full")) {
            $(document.body).removeClass("compare-full");
        }
    },

    //UI : REMOVE ONE ITEM : Delete Single item from compareList
    removeItem: function( e, id ) {
        var compareList = this.state.compareList.filter( function( item ) {
            return item.id !== id;
        });
        this.updateState({ compareList: compareList });
        localStorage.setItem( 'compare-list', JSON.stringify( this.state.compareList ) );
        if (this.state.panel == "full") {
            this.updateState({
                panel: this.state.compareList.length > 0 ? 'full' : 'hidden'
            })
            if (this.state.compareList.length === 0) {
                if($(document.body).hasClass("compare-full")) {
                    $(document.body).removeClass("compare-full");
                }
            }
        }

        if (this.state.panel == "mini") {
            this.updateState({
                panel: this.state.compareList.length > 0 ? 'mini' : 'hidden'
            })
            if (this.state.compareList.length === 0) {
                if($(document.body).hasClass("compare-full")) {
                    $(document.body).removeClass("compare-full");
                }
            }
        }

    // remove what is in the shared url result container so it can update when the user clicks 'share' again
     $(".display-results").empty();

    // returns share button back to normal state and changes back the onclick function
     $(".share-url-btn").attr("onclick","shareURL()");
     $(".share-url-btn").text("Share");
    },

    //UI : REMOVE ALL ITEMS : Delete all items from compare list
    removeAll: function() {
        this.updateState({ compareList: [] });
        localStorage.setItem( 'compare-list', null );
        this.updateState({ panel: 'tab' });
        this.updateState({
            panel: this.state.compareList.length > 0 ? 'tab' : 'hidden'
        })
        if (this.state.compareList.length === 0) {
          if($(document.body).hasClass("compare-full")) {
            $(document.body).removeClass("compare-full");
          }
        }
    },

    // UI : EXPAND TAB : Open panel when you click "compare tab"
    expandTab: function() {
        this.updateState({ panel: 'mini' });
    },

    // UI : OPEN FULL COMPARE : Open full view when you click "Compare" button in mini mode
    expandFullCompare: function() {
        this.updateState({ panel: 'full' });
        $(document.body).addClass("compare-full");
    },

    // UI : STATE UPDATE : Update state and trigger a render
    updateState: function( newState ) {
        newState.warning = newState.warning || 'hidden'; //reset warning state if not passed
        this.state = Object.assign( {}, this.state, newState ); // Update state, don't wipe unpased keys
        this.renderContent();
    },

    // ACTION : FETCH PRODUCT DATA : Preps adding to compare tool by fetching its metadata
    addCompareProduct: function( productHandle ) {
        //BUTTON : Disable compare button until fully added to compare drawer
        var clickedBtn = $( this.target );
        function toggleCompareBtn( toggleState ) { clickedBtn.attr( 'data-compare-is-adding', toggleState ) }
        toggleCompareBtn( 'true' ); //Disable button until we process add request

        // LIST : Is it already on the list?
        var compareList = this.state.compareList; //Readability
        var isAlreadyAdded = compareList.find( function( listItem ) {
            return listItem.handle === productHandle;
        });

        // FETCH : SPECS : List isn't full, fetch specs & add to UI list
        if ( compareList.length < 3 && !isAlreadyAdded ) {
            var self = this;

            //FETCH : Grab full object for 'full' compare view line items
            $.ajax( '/products/' + productHandle + '?view=compare' )
                .done( function( res ) {
                    self.addProductToList( JSON.parse( res ) );
                })
                .fail( function() {
                    self.updateState({
                        panel: 'mini', //Show warning in 'mini' mode if in 'tab' mode
                        warning: 'no-internet'
                    })
                })
                .always(function() {
                    toggleCompareBtn( 'false' ); // Re-enable that compare button
                });

        // ERROR CASE : Max Items or Item is Already in List
        } else {
            this.updateState({
                panel: 'mini', //Show warning in 'mini' mode if in 'tab' mode
                warning: isAlreadyAdded ? 'already-added' : 'max-items'
            })
            toggleCompareBtn( 'false' ); // Re-enable product compare button
        }
        // when user selects new item the share button returns to it's natural state
        $(".share-url-btn").attr("onclick","shareURL()");
        // $(".share-url-btn").text("Share");
        $(".display-results").empty();
    },


    // ACTION : ADD TO LIST : Adds fetched product to the state (from addCompareProduct call completion)
    addProductToList: function( item ) {
        var compareList = this.state.compareList;
        var isAlreadyAdded = compareList.find( function( listItem ) {
            return listItem.handle === item.handle;
        });

        // Rapid compare btn clicks can slip between even dom disable of button, check once more before adding to list again
        if ( !isAlreadyAdded ) {

            // STATE : Add to compare list state and render
            compareList.push( item );
            UrlList.push(item);
            this.updateState({
                compareList: compareList,
                panel: 'mini' //'Mini' so it shows up if in tab mode
            })

            // STORE : Update local storage with new list
            localStorage.setItem( 'compare-list', JSON.stringify( this.state.compareList ) ); // TODO : Add timestamp for expirations
            localStorage.setItem("url-list", JSON.stringify(UrlList));
        }
    },

    // Accepts an integer from 0-5 and builds a star group for that integer.
    getStars: function ( rating ) {
        // Round to nearest half
        rating = Math.round(rating * 2) / 2;
        let output = [];

        // Append all the filled whole stars
        for (var i = rating; i >= 1; i--)
            output.push('<i class="fa fa-star" aria-hidden="true" style="color: #eb6e26;"></i>&nbsp;');

        // If there is a half a star, append it
        if (i == .5) output.push('<i class="fa fa-star-half-o" aria-hidden="true" style="color: #eb6e26;"></i>&nbsp;');

        // Fill the empty stars
        for (let i = (5 - rating); i >= 1; i--)
            output.push('<i class="fa fa-star-o" aria-hidden="true" style="color: #eb6e26;"></i>&nbsp;');
        return output.join('');
    },

    addToCart: function( e, id ) {
        // Prevent repeated clicks on Add To Cart from adding multiple products mistakenly (QA Feedback)
        if ( this.state.addingToCart ) {
            return;
        }
        this.updateState({ addingToCart: true }); // QA Feedback - rapid clicks on "add to cart" adds multiple

        // BUILD : CART ITEM : Setup product item object data
        var self = this; // For success / error handlers
        var item = this.state.compareList.find( function( item ) {
            return item.id === id
        });
        var properties = null;
        var options = {};
        var cartItem = {
            "barcode" : item.barcode,
            "compare_at_price" : item.compare_at_price,
            "id" : item.id,
            "option1" : item.option1,
            "option2" : item.option2,
            "price" : item.price,
            "sku" : item.sku,
            "title" : item.title
        };

        // PRE-ORDER : if tagged 'preorder' add the preorder data to cart item
        if ( /preorder/gi.test( item.tags ) ) {
            properties = {
                'preorder' : 'true', //String Intentional, copy from other add-to-cart actions
                'preorderShipDate' : item.preOrderShipDate | '' //Casing intentional, needed for cart to read it properly
            };
        }

        // ADD-TO-CART : ERROR
        options.error = function() {
            self.updateState({
                addingToCart: false,
                warning: 'add-cart-error'
            });
        }

        // ADD-TO-CART : SUCCESSFUL
        options.success = function() {
            self.updateState({
                addingToCart: false,
                panel: 'tab'
            });
            modules.tealium.addToCart( cartItem, 1 );
            theme.minicart.slideout();
        }
        if($(document.body).hasClass("compare-full")) {
            $(document.body).removeClass("compare-full");
        }

        // ADD-TO-CART : Add our item to the cart, cb will call "success" or "error" on completion
        shopify.cart.addItem( item.variantId, 1, properties, options );
    },

    // UI : TEMPLATE : Mini view item template handler
    // NOTE : Best reason to keep this here vs in a snippet included into product.json.liquid
    //        is on the init so we don't have to do extra fetches when 1st loading localStorage
    miniItem_HTML: function( item ) {
        var template = ''; //Empty Template, item = # in circle
        if ( item && item.title ) {
            var bundleText = item.available ? `${item.buttonTranslations.addToCart}` : item.buttonTranslations.soldOut;
            var productPrice = '<div class="product-price sale-price">' + item.price + '</div>';
            if (item.compare_at_price){
              var productPrice = '<div class="modal-compare-price compare-price">' + item.compare_at_price + '</div>' + '<div class="product-price sale-color compare-sale-price">' + item.price + '</div>';
            } else {

            }

            if (item.type = "Bundle") {
                var template = ( // bundle item template
                    '<li class="compare-item product '+item.url+'">' +
                    '<button class="compare-remove-item" id="compare-remove-item" onClick="$(this).trigger( \'removeCompareItem\', ' + item.id + ' )">X</button>' +
                    `<a href="${item.url}" ><img src="${item.imgUrl}" alt="${item.title}"></a>` +
                    '<div class="product-text-wrap">' +
                        '<div class="product-name">' + item.title + '</div>' +
                        productPrice +
                    '</div>' +
                    `<button class="compare-add-to-cart btn btn--primary" onClick="$(this).trigger('addCompareItemToCart', ${item.id} )" data-available="${item.available}"> ${bundleText}</button>` +
                    '</li>'
                );
            } else {
                var template = ( // Item template
                    '<li class="compare-item product">' +
                    '<button class="compare-remove-item" id="compare-remove-item" onClick="$(this).trigger( \'removeCompareItem\', ' + item.id + ' )">X</button>' +
                    `<a  href="${item.url}" ><img src="${item.imgUrl}" alt="${item.title}"></a>` +
                    '<div class="product-text-wrap">' +
                        '<div class="product-name">' + item.title + '</div>' +
                        productPrice +
                    '</div>' +
                    `<button class="compare-add-to-cart btn btn--primary" onClick="$(this).trigger('addCompareItemToCart', ${item.id} )" data-available="${item.available}"> ${bundleText}</button>` +
                    '</li>'
                );
            }

        }

        return template;
    },

    // UI : TEMPLATE : Single Spec entry within a row of spec data in specList_HTML (RE: 'Full' view)
    specItem_HTML: function( item, label ) {
        var specData = '-';
        // var rating = theme.CompareModal.getStars(this.reviewsAverage);
        // ITEM : Map label data to spec data-point + render div el
        if ( item && item.compareSpecs && label ) {

            // SPEC DATA : Grab spec value + account for "wired / wireless" cases by scanning both fields (last one wins if both have value, shouldn't though)
            var parsedLabel = label.split( ' / ' ); //Returns Arr
            parsedLabel.map( function( spec ) {
                spec = slate.utils.camelize( spec ); //Labels --> Camel Case for spec lookup

                // check and see if label is the "rating" label of the compare overlay
                if (label === "rating"){
                // give the specdata the review integer as match data so we can pull it into the modal
                    if (item.reviewsAverage > 0.0){
                        var matchedSpec = item.reviewsAverage;
                    }
                } else {
                  var matchedSpec = item[ spec ] || item.compareSpecs[ spec ]; //item[spec] for price, rest fall into item.compareSpecs[ spec ]; (price added to all comapreSpecs before this was built)
                }

                if ( matchedSpec ) {

                   // checking if label is our newly added rating label / rating integer

                  if( label === "rating" ){
                   // replacing review integer with appropriate star icon
                    specData = theme.CompareModal.getStars(item.reviewsAverage);
                  } else if( label === "price" && item.compare_at_price ){
                    specData = '<div class="modal-compare-price compare-price">' + item.compare_at_price + '</div>' + '<div class="sale-color bottom-product-price">' + item.price + '</div>'
                  }else {
                    // value = 'true' : use label name instead. (Wired/Wireless spec shouldn't show as "true" lol)
                    specData = /true/gi.test( matchedSpec ) ? spec : matchedSpec;

                    // 'Empty' VALUE : Some items have bad Data, replace "Empty" with '-'
                    specData = specData.replace( /empty/i, '-' );
                  }
                }
            });
        }
        /* SAMPLE : Add-To-Cart footer button :
            <div class="spec-item"><button class="compare-add-to-cart btn btn--secondary">Add to Cart</button></div>
        */
            return '<div class="spec-item">' + specData + '</div>';

    },

    // UI : TEMPLATE : Handles rendering the list of spec data rows on 'Full' view mode
    specList_HTML: function() {
        var compareList = this.state.compareList;
        var specItem_HTML = this.specItem_HTML;
        var labelTranslations = compareList[0].labelTranslations; //Cant get here w/o 1 item, so always read first item
        var specListHTML = '';

        // TEMPLATE : Build HTML Spec Rows from 'settings.specs_to_compare' (Arr) pulled from data-attr in compare-modal.liquid
        if ( compareList.length !== 0 ) { //Safety
            this.state.specLabels.forEach( function( label ) {
                var translatedLabel = labelTranslations[label] || label;
                // SPEC-ITEM: Build spec-item <div> for each item in state.compareList
                var specItemHTML = '';
                for ( var i = 0; i < Math.min(compareList.length, 3); i++ ) { //For loop so we fill empty slots with empty tpl
                    specItemHTML += specItem_HTML( compareList[i], label );
                }


                // SPEC-ROW : Build full row of comparable spec-items
                specListHTML += (
                    '<li class="spec-row one-whole">' +
                        '<div class="label">' + translatedLabel + '</div>' + //Translate label, fallback if not found
                        specItemHTML +
                    '</li>'
                );

            });
        }

        return specListHTML;
    },


    // RENDER : Render various pieces into compare modal
    renderContent: function () {
        var state = this.state; //Cant use destructuring :(
        var selectors = this.selectors;

        // ITEM LIST : MINI : List for 'mini' view, head section on 'full' view
        var compareMiniHTML = '';
        for ( var i = 0; i < 3; i++ ) { //For loop so we fill empty slots with empty tpl
            compareMiniHTML += this.miniItem_HTML( state.compareList[i] || i + 1 ); //Render compare list items
        }

        // SPEC LIST : FULL : List for full spec comparision
        var compareSpecListHTML = state.compareList.length > 0 ? this.specList_HTML() : '';

        // RENDER UI INTO DOM ELEMENTS
        $( selectors.compareList ).html( compareMiniHTML );  //List of Items (Mini & Top of Full View)
        $( selectors.compareSpecList ).html( compareSpecListHTML ); // List of Specs (Full view)
        $( selectors.compareTabCount ).html( '(' + state.compareList.length + ')' ); //Tab View, wont matter if 0 - wont render visibly
        $( selectors.compareModal ).attr({
            'data-compare-state': state.panel,
            'data-compare-warning': state.warning,
            'data-compare-enable': state.compareList.length > 0 //Any items selected yet? disable button if not
        });

        // FULL-SCREEN MODAL : Avoid Double Scrollbars while in 'Full' Compare Mode
        $( selectors.modalOnScreenFlag ).attr( 'data-modal-on-screen', state.panel === 'full' );

        if (window.location.href.indexOf("fr.") > -1) {
            $('.spec-item:contains("wired")').html('filaire');
            $('.spec-item:contains("wireless")').html('sans fil');

            var addToCartButton = $('.compare-add-to-cart.btn');
            addToCartButton.css('font-size', '10px');
        }

        if (window.location.href.indexOf("it.") > -1) {
            $('.spec-item:contains("wired")').html('cavo');
            $('.spec-item:contains("wireless")').html('senza cavo');

            var addToCartButton = $('.compare-add-to-cart.btn');
            addToCartButton.css('font-size', '10px');
        }

        if (window.location.href.indexOf("es.") > -1) {
            $('.spec-item:contains("wired")').html('con cable');
            $('.spec-item:contains("wireless")').html('sin cable');

            var addToCartButton = $('.compare-add-to-cart.btn');
            addToCartButton.css('font-size', '10px');
        }

        if (window.location.href.indexOf("de.") > -1) {
            $('.spec-item:contains("wired")').html('kabelgebunden');
            $('.spec-item:contains("wireless")').html('kabellos');

            var addToCartButton = $('.compare-add-to-cart.btn');
            addToCartButton.css('font-size', '10px');
        }

        if (window.location.href.indexOf("nl.") > -1) {
            $('.spec-item:contains("wired")').html('bekabeld');
            $('.spec-item:contains("wireless")').html('draadloos');

            var addToCartButton = $('.compare-add-to-cart.btn');
            addToCartButton.css('font-size', '10px');
        }

        var warningWrapper = $('#compare-warning');
        var wrapperHeight = warningWrapper.height();
        var warningHeight = Math.abs(wrapperHeight) * -1;

        warningWrapper.css('top', warningHeight);
    },

   customContent: function() {


         // capturing url and storing it
         var url = window.location.href;

         //clear local storage just in case the user already has something in their co
         // localStorage.clear();

         // seeing what parameters we have so we can add them to an array
         var getUrlParameter = function getUrlParameter(sParam) {
         var sPageURL = window.location.search.substring(1),
             sURLVariables = sPageURL.split('?'),
             sParameterName,
             i;

         for (i = 0; i < sURLVariables.length; i++) {
             sParameterName = sURLVariables[i].split('=');

             if (sParameterName[0] === sParam) {
                 return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
             }
            }
          };

     // split added parameters and turn them into an array
      var IDS = getUrlParameter('compareIDs');
      var IDarray = IDS.split(',');
      var newSpecList = '';
      // loop through array and append value to modal
      for (i = 0; i < IDarray.length; i++){

            //FETCH : Grab full object for 'full' compare view line items
            $.ajax( '/products/' + IDarray[i] + '?view=compare' )
                .done( function( res ) {
                  theme.CompareModal.addProductToList( JSON.parse( res ) );
                  theme.CompareModal.expandFullCompare();
                })
                .fail( function() {
                  console.log("compare ID ajax call fail");
                })
                .always(function() {
                });
      }

   }
}


/*==========================================================================================
  Checking to see if the URL is our created URL we are gave the previous user
===========================================================================================*/

if (window.location.href.indexOf("compareIDs") > -1) {
  theme.CompareModal.customContent();
  productID = '';
}
/**
 * Tealium helpers
 * -----------------------------------------------------------------------------
 * Events for sending data to tealium
 *
 * @namespace modules
 */

modules.tealium = {
    addToCart: function(item, qty) {
        if (typeof utag == "undefined" || typeof utag_data == "undefined")
            return;        

        if (item.title == null || item.title == undefined)
            item.title = item.name;
        
        var cart_utag = {
            "event": "scAdd",
            "page" : "myBag",
            "page_type" : "shopping cart",
            "page_name" : utag_data.page_name || "",
            "product_id": "" + item.id + "",
            "product_name": item.title, 
            "product_mfgsku": item.sku,
            "product_current_category": "",
            "product_current_price": slate.Currency.formatMoney(item.price, '{{amount}}'),
            "product_regular_price": slate.Currency.formatMoney(item.compare_at_price == null ? item.price : item.compare_at_price, '{{amount}}'),
            "product_is_on_sale": item.compare_at_price == null ? 'false' : 'true',
            "product_size": item.option1 || "",
            "product_color": item.option2 || "",
            "product_quantity": "" + qty + "",
            "product_upc": item.barcode,
            "customer_email": utag_data.customer_email || "",
            "customer_id": utag_data.customer_id || "",
            "customer_status": utag_data.customer_status || ""                    
        };

        utag.view(cart_utag);
    },
    removeCartItem: function(item) {
        if (typeof utag == "undefined" || typeof utag_data == "undefined" || !item )
            return;
        
        var cart_utag = {
            "event": "scRemove",
            "page" : "myBag",
            "page_type" : "shopping cart",
            "page_name" : utag_data.page_name || "",
            "product_id": "" + item.id + "",
            "product_name": item.title, 
            "product_mfgsku": item.sku,
            "product_current_category": "",
            "product_current_price": slate.Currency.formatMoney(item.price, '{{amount}}'),
            "product_regular_price": slate.Currency.formatMoney(item.compare_at_price == null ? item.price : item.compare_at_price, '{{amount}}'),
            "product_is_on_sale": item.compare_at_price == null ? 'false' : 'true',
            "variant_options": item.variant_options || [],
            "product_quantity": "" + item.quantity + "",
            "customer_email": utag_data.customer_email || "",
            "customer_id": utag_data.customer_id || "",
            "customer_status": utag_data.customer_status || "" 
        };

        utag.view(cart_utag);  
      },        
}
/**
 * Footer Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled code to the Footer.
 *
   * @namespace Footer
 */

theme.Footer = (function() {

    var selectors = {
      miniCartOverlay: "[data-cart-mini-overlay]",
      mobileHeader: ".mobile-header",
      mobileNavigation: "[data-mobile-nav-container]"
    };

    function Footer(container) {
        this.$container = $(container);
        this.namespace = '.footer';
        this.init();
    }

    Footer.prototype = $.extend({}, Footer.prototype, { 
      init: function() {
        
      },

      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function() {
        this.$container.off(this.namespace);
      }
    });

   return Footer;
})();

$('#search, #search-mobile').keydown(function (event) {
  if (event.keyCode === 13) {
      $(this).parents('form').submit();
  }
});

var footerMetaNavLinks = document.querySelectorAll('.footer-meta-navigation a');
if (footerMetaNavLinks && window.location.href.includes('.com/fr')) {
  for (var i=0; i<footerMetaNavLinks.length; i++) {
    var href = footerMetaNavLinks[i].href;
    let url = new URL(href);
    let domain = url.hostname;

    if (domain === "www.levelaccess.com") {
      href = href.replace('/a/turtlebeach', '/a/turtlebeach-fr');
      footerMetaNavLinks[i].href = href;
    } else {
      href = href.split('.com');
      footerMetaNavLinks[i].href = href[0] + '.com/fr' + href[1];
    }
  }
}

/**
 * Shopping Guide Scripts
 * ------------------------------------------------------------------------------
 * A file that contains scripts tightly coupled code to the Shopping Guide
 *
   * @namespace shoppingGuide
 */

theme.ShoppingGuide = (function() {
    var sg_results = $('.pf-results-row > div');

    sg_results.removeClass('pf-col-md-4').addClass('pf-col-md-3');
 })
/**
 * DoGemCustom Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled code to the custom Gems built for
 * journey pages. The body:not(.gempage-editing) selector is set to not allow 
 * these scripts to init while in gempage admin, it would cause issues on content
 * management, and sometimes hidden content would not be saved in the admin.
 *
 * .gryffeditor class is gempage specific
 *
   * @namespace DoGemCustom
 */


/**
 * Prevent Default Scroll Position
 * Class is added onto Hero Section of each gempage
 */
if ($('body:not(.gempage-editing) .gryffeditor .js-scroll-up').length > 0) {
    history.scrollRestoration = "manual";
    $(window).on('unload', function(){
        $(window).scrollTop(0);
    });
}


/**
 * PC ONLY
 * AJAX load data from external gempages. PC was broken out into 4 pages total.
 * URLs should be the same across all stores. Relative pathing.
 * /pages/pc-features-only
 * AJAX loads data, triggers slick slider and matchehight
 * Tab click event reset slide position
 */
if ($('body:not(.gempage-editing) .gryffeditor .pc2.tab-section').length > 0) {
    // Observer
    var gemInterval = setInterval(function(){
        //console.log('Loading not complete...');
        if($('body:not(.gempage-editing).js-ajax-gem-load-complete-1.js-ajax-gem-load-complete-2.js-ajax-gem-load-complete-3.js-ajax-gem-load-complete-4.js-ajax-gem-load-complete-5').length > 0) {
            clearInterval(gemInterval);
            //console.log('Journey loading completed.');
            // Load  JS for sliders and etc
            gemFeature();
            // MatchHeight
            var gemSectionFeatureMatch = $('body:not(.gempage-editing) .feature-section .item-content');
            gemSectionFeatureMatch.find('div[data-label="Text Block"]').matchHeight();
            gemSectionFeatureMatch.find('h4').matchHeight();
        }
    }, 50);
    // on Load
    $('body:not(.gempage-editing) .feature-slider.feature-1').load( '/pages/pc-features-only .feature-slider.feature-1 > .gf_column', function() {
        $('body:not(.gempage-editing)').addClass('js-ajax-gem-load-complete-1');
        //console.log('Journey 1 loading complete.');
    });
    $('body:not(.gempage-editing) .feature-slider.feature-2').load( '/pages/pc-features-only .feature-slider.feature-2 > .gf_column', function() {
        $('body:not(.gempage-editing)').addClass('js-ajax-gem-load-complete-2');
        //console.log('Journey 2 loading complete.');
    });
    $('body:not(.gempage-editing) .feature-slider.feature-3').load( '/pages/pc-features-only .feature-slider.feature-3 > .gf_column', function() {
        $('body:not(.gempage-editing)').addClass('js-ajax-gem-load-complete-3');
        //console.log('Journey 3 loading complete.');
    });
    $('body:not(.gempage-editing) .feature-slider.feature-4').load( '/pages/pc-features-only .feature-slider.feature-4 > .gf_column', function() {
        $('body:not(.gempage-editing)').addClass('js-ajax-gem-load-complete-4');
        //console.log('Journey 4 loading complete.');
    });
    $('body:not(.gempage-editing) .feature-slider.feature-5').load( '/pages/pc-features-only .feature-slider.feature-5 > .gf_column', function() {
        $('body:not(.gempage-editing)').addClass('js-ajax-gem-load-complete-5');
        //console.log('Journey 5 loading complete.');
    });
}


/**
 * Generic variables
 * Conforming general aniations speeds and etc.
 */
if ($('body:not(.gempage-editing) .gryffeditor').length > 0) {
    var gemSectionSpeed = 600;
}


/**
 * Generic Body Attribute
 * Journey Path from CSS toggles path
 * data-journey = parent tab path
 * data-product = product path
 */
if ($('body:not(.gempage-editing) .gryffeditor').length > 0) {
    $('body:not(.gempage-editing)').attr({ 'data-journey':'0', 'data-journey-product':'1' });
}

/**
 * Gem Hero
 * js anchor link emulator
 * Traverses to next gf-row element unless it is the last.
 */
if ($('body:not(.gempage-editing) .gryffeditor .hero-section').length > 0) {
    $('body:not(.gempage-editing) .hero-section').each(function(){
        var gemSectionHero             = $(this),
            gemSectionHeroAnchor       = gemSectionHero.find('.text-anchor > p'),
            gemSectionHeroAnchorTarget = $(this).closest('.hero-section').next('.gf_row');
        // Anchor
        if (gemSectionHeroAnchor.length > 0) {
            gemSectionHeroAnchor.on('click touchstart', function(){
                if (gemSectionHeroAnchorTarget.length > 0) {
                    $('html, body').animate({ scrollTop: gemSectionHeroAnchorTarget.offset().top }, gemSectionSpeed);
                }
            });
        }
    });
}


/**
 * Gem Mosaic
 * Slick and js anchor link emulator
 */
function gemMosaic() {
    if ($('body:not(.gempage-editing) .gryffeditor .mosaic-section').length > 0) {
        $('body:not(.gempage-editing) .mosaic-section').each(function(){
            var gemSectionMosaic             = $(this),
                gemSectionMosaicContainer    = gemSectionMosaic.find('.mosaic-square.mosaic-slider > div:first-child'),
                gemSectionMosaicSquare       = gemSectionMosaic.find('.mosaic-square'),
                gemSectionMosaicTrigger      = gemSectionMosaic.find('.text-link > p'),
                gemSectionMosaicSlides       = gemSectionMosaic.find('.mosaic-slide'),
                gemSectionMosaicAnchor       = gemSectionMosaic.find('.text-anchor'),
                gemSectionMosaicAnchorTarget = gemSectionMosaic.find('.mosaic-square.mosaic-review');
            // Slick
            if( gemSectionMosaicSlides.length > 1 ) {
                gemSectionMosaicContainer.slick({
                    arrows: true,
                    infinite: true,
                    centerMode: false,
                    slidesToScroll: 1,
                    nextArrow: gemSectionMosaicTrigger,
                    slidesToShow: 1,
                    speed: gemSectionSpeed
                });
            }
            // Anchor
            if (gemSectionMosaicAnchor.length > 0) {
                gemSectionMosaicAnchor.on('click touchstart', function(){
                    if (gemSectionMosaicAnchorTarget.length > 0) {
                        $('html, body').animate({ scrollTop: gemSectionMosaicAnchorTarget.offset().top }, gemSectionSpeed);
                    }
                });
            }
        });
    }
}
gemMosaic();

/**
 * Gem Champ
 * Slick and js anchor link emulator
 */
function gemChamp() {
    if ($('body:not(.gempage-editing) .gryffeditor .champ-section').length > 0) {
        $('body:not(.gempage-editing) .champ-section').each(function(){
            var gemSectionChamp             = $(this),
                gemSectionChampContainer    = gemSectionChamp.find('.champ-slider > .gf_column'),
                gemSectionChampSlides       = gemSectionChampContainer.find('.slide'),
                gemSectionChampAnchor       = gemSectionChamp.find('.text-anchor > p'),
                gemSectionChampAnchorTarget = gemSectionChamp.find('.text-target');
            // Slick
            if( gemSectionChampSlides.length > 1 ) {
                gemSectionChampContainer.slick({
                    arrows: true,
                    centerMode: true,
                    infinite: true,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    speed: gemSectionSpeed,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                centerMode: false
                            }
                        }
                    ]
                });
            }
            // Anchor
            if (gemSectionChampAnchor.length > 0) {
                gemSectionChampAnchor.on('click touchstart', function(){
                    $('html, body').animate({ scrollTop: gemSectionChampAnchorTarget.offset().top - 20 }, gemSectionSpeed);
                });
            }
        });
    }
}
gemChamp();

/**
 * Gem Feature
 * Slick, MatchHeight and js anchor link emulator
 */
function gemFeature() {
    if ($('body:not(.gempage-editing) .gryffeditor .feature-section').length > 0) {
        $('body:not(.gempage-editing) .feature-section').each(function(){
            var gemSectionFeature             = $(this),
                gemSectionFeatureContainer    = gemSectionFeature.find('.feature-slider > .gf_column'),
                gemSectionFeatureSlides       = gemSectionFeatureContainer.find('.slide'),
                gemSectionFeatureItemContent  = gemSectionFeature.find('.item-content'),
                gemSectionFeatureAnchor       = gemSectionFeature.find('.text-anchor > p'),
                gemSectionFeatureAnchorTarget = gemSectionFeature.find('.text-target');
            // MatchHeight
            if (gemSectionFeatureItemContent.length > 0) {
                gemSectionFeatureItemContent.attr('data-mh','feature-container');
                gemSectionFeatureItemContent.find('h4').attr('data-mh','feature-content-title');
                gemSectionFeatureItemContent.find('div[data-label="Text Block"]').attr('data-mh','feature-content');
            }
            // Slick
            if( gemSectionFeatureSlides.length > 1 ) {
                gemSectionFeatureContainer.slick({
                    arrows: true,
                    infinite: true,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    speed: gemSectionSpeed
                });
            }
            // Anchor
            if (gemSectionFeatureAnchor.length > 0) {
                gemSectionFeatureAnchor.on('click touchstart', function(){
                    $('html, body').animate({ scrollTop: gemSectionFeatureAnchorTarget.offset().top - 20 }, gemSectionSpeed);
                });
            }
        });
    }
}
gemFeature();


/**
 * Gem Products
 * Slick, MatchHeight and js anchor link emulator
 */
if ($('body:not(.gempage-editing) .gryffeditor .shop-section').length > 0) {
    $('body:not(.gempage-editing) .shop-section').each(function(){
        var gemSectionShop                = $(this),
            gemSectionShopProductWrap     = gemSectionShop.find('.product-list > .gf_icon-list'),
            gemSectionShopProductWrapList = gemSectionShop.find('.product-list > .gf_icon-list > li'),
            gemSectionShopProduct         = gemSectionShop.find('div[data-label="Product"]'),
            gemSectionShopProductImage    = gemSectionShopProduct.find('div[data-icon="gpicon-product-image"]'),
            gemSectionShopProductTitle    = gemSectionShopProduct.find('div[data-icon="gpicon-product-title"]'),
            gemSectionShopProductPrice    = gemSectionShopProduct.find('div[data-icon="gpicon-product-price"]'),
            gemSectionShopProductSubtitle = gemSectionShopProduct.find('div[data-icon="gpicon-textblock"]'),
            gemSectionShopProductList     = gemSectionShopProduct.find('div[data-icon="gpicon-iconlist"]'),
            gemSectionShopProductButton   = gemSectionShopProduct.find('div[data-icon="gpicon-product-cartbutton"]'),
            gemSectionShopAnchor          = gemSectionShop.find('.text-anchor > p'),
            gemSectionShopAnchorTarget    = gemSectionShop.find('.text-target');
        // Slick
        if (gemSectionShopProductWrapList.length > 1) {
            var gemSectionProductCount = gemSectionShopProductWrapList.length;
            // Count and HTML class
            if (gemSectionShopProductWrapList % 2 != 0) {
                gemSectionShopProductWrap.addClass('odd js-count-' + gemSectionProductCount);
            } else {
                gemSectionShopProductWrap.addClass('even js-count-' + gemSectionProductCount);
            }
            if (gemSectionShopProductWrapList.length === 2) {
                // 2 or less
                gemSectionShopProductWrap.slick({
                    arrows: true,
                    infinite: true,
                    slidesToScroll: 1,
                    slidesToShow: 2,
                    speed: gemSectionSpeed,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            } else {
                // 3 and Greater
                gemSectionShopProductWrap.slick({
                    arrows: true,
                    infinite: true,
                    slidesToScroll: 1,
                    slidesToShow: 3,
                    speed: gemSectionSpeed,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 1
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            }
        }
        // MatchHeight
        if (gemSectionShopProduct.length > 0) {
            // Selector targeting has to be exact for items below
            gemSectionShop.find('div[data-label="Heading"] .product-title h3').attr('data-mh','product-title');
            gemSectionShop.find('div[data-icon="gpicon-product-title"] a').attr('data-mh','product-title-default');
            gemSectionShop.find('.gf_product-prices').attr('data-mh','product-price');
            gemSectionShop.find('div[data-icon="gpicon-product-price"] + div p').attr('data-mh','product-subtitle');
            gemSectionShop.find('div[data-label="Icon List"]').attr('data-mh','product-list');
        }
        // Anchor
        if (gemSectionShopAnchor.length > 0) {
            gemSectionShopAnchor.on('click touchstart', function(){
                $('html, body').animate({ scrollTop: gemSectionShopAnchorTarget.offset().top - 20 }, gemSectionSpeed);
            });
        }
    });
}


/**
 * Gem Reviews Slider
 * Slick, js anchor link emulator
 * Traverses to next gf-row element unless it is the last.
 */
if ($('body:not(.gempage-editing) .gryffeditor .review-section').length > 0) {
    $('body:not(.gempage-editing) .review-section').each(function(){
        var gemSectionReview             = $(this),
            gemSectionReviewSlides       = gemSectionReview.find('.slide .slide-content'),
            gemSectionReviewContainer    = gemSectionReview.find('.slide > div:first-child'),
            gemSectionReviewTrigger      = gemSectionReview.find('.text-link p'),
            gemSectionReviewAnchor       = gemSectionReview.find('.text-anchor > p'),
            gemSectionReviewAnchorTarget = gemSectionReview.find('.text-target');
        // Slick
        if( gemSectionReviewSlides.length > 1 ) {
            gemSectionReviewContainer.slick({
                arrows: true,
                infinite: true,
                nextArrow: gemSectionReviewTrigger,
                slidesToScroll: 1,
                slidesToShow: 1,
                speed: gemSectionSpeed
            });
        }
        // Anchor
        if (gemSectionReviewAnchor.length > 0) {
            gemSectionReviewAnchor.on('click touchstart', function(){
                if (gemSectionReviewAnchorTarget.length > 0) {
                    $('html, body').animate({ scrollTop: gemSectionReviewAnchorTarget.offset().top }, gemSectionSpeed);
                }
            });
        }
    });
}


/**
 * Gem Single Shop
 * js anchor link emulator
 * Traverses to next gf-row element unless it is the last.
 */
if ($('body:not(.gempage-editing) .gryffeditor .shop-single-section').length > 0) {
    $('body:not(.gempage-editing) .shop-single-section').each(function(){
        var gemSectionShopSingle             = $(this),
            gemSectionShopSingleAnchor       = gemSectionShopSingle.find('.text-anchor > p'),
            gemSectionShopSingleAnchorTarget = gemSectionShopSingle.find('.text-target');
        // Anchor
        if (gemSectionShopSingleAnchor.length > 0) {
            gemSectionShopSingleAnchor.on('click touchstart', function(){
                if (gemSectionShopSingleAnchorTarget.length > 0) {
                    $('html, body').animate({ scrollTop: gemSectionShopSingleAnchorTarget.offset().top }, gemSectionSpeed);
                }
            });
        }
    });
}


/**
 * Gem Journey Toggle
 * Custom toggle elements via body data-journey attribute combined with CSS
 * Matchheight and Product selection Resets.
 * Tab functionality uses Gem Icon Horizontal Lists module. Referring to the
 * data-index attribute. Journey order MUST match. Tabs data-index updates body
 * attribute. CSS controls display of active tab.
 */
if ($('body:not(.gempage-editing) .gryffeditor .tab-section').length > 0) {
    $('body:not(.gempage-editing) .tab-section').each(function(){
        var gemSectionTab                = $(this),
            gemSectionTabTriggers        = gemSectionTab.find('li'),
            gemSectionTabTriggersIcons   = gemSectionTabTriggers.find('.do-icon'),
            gemSectionTabTriggersHeading = gemSectionTabTriggers.find('h4');
        // MatchHeight
        if (gemSectionTabTriggers.length > 0) {
            gemSectionTabTriggersHeading.attr('data-mh','tab-title');
        }
        // Click
        gemSectionTabTriggersIcons.on('click touchstart', function(){
            var gemSectionJourneyNumber = $(this).closest('.item-content').attr('data-index');
            // Grabs data-index attribute and updates body attribute
            $('body').attr('data-journey',gemSectionJourneyNumber);
            //console.log('Journey Path: '+ gemSectionJourneyNumber);
            // Resets Product selection
            $('body').attr('data-journey-product', '1');
            if ($('.product-select-section').length > 0) {
                $('.product-select-section').find('.item-content.js-active').removeClass('js-active');
                // On Load - select first
                $('.product-select-section').find('li:first-child > div').addClass('js-active');
            }
            // Reset slides - add into array, each resets slide
            var gemSectionTabSliders = [
                '.mosaic-section .mosaic-square.mosaic-slider > div:first-child',
                '.shop-section .product-list > .gf_icon-list',
                '.review-section .slide > div:first-child',
                '.champ-section .champ-slider > .gf_column',
                '.feature-section .feature-slider > .gf_column'
            ];
            // Reset sliders from array above
            $.each( gemSectionTabSliders, function( index, value ) {
                if( $(value).length > 0) {
                    $(value).slick('slickGoTo', 0);
                }
            });
            // Active States
            $(this).addClass('js-active');
            gemSectionTabTriggersIcons.not($(this)).removeClass('js-active');
        });
    });
}


/**
 * Gem Product Select Toggle
 * Custom toggle elements via body data-journey-product attribute combined with
 * CSS and matchheight. (Expanded from Gem Journey Toggle)
 * Tab functionality uses Gem Icon Horizontal Lists module. Referring to the
 * data-index attribute. Journey order MUST match. Tabs data-index updates body
 * attribute. CSS controls display of active tab.
 */
function gemProductSelect() {
    if ($('body:not(.gempage-editing) .gryffeditor .product-select-section').length > 0) {
        var gemSectionSelect                = $('.product-select-section'),
            gemSectionSelectTriggers        = gemSectionSelect.find('li'),
            gemSectionSelectTriggersHeading = gemSectionSelectTriggers.find('h5');
        // On Load - select first
        gemSectionSelect.find('li:first-child > div').addClass('js-active');
        // Click
        gemSectionSelectTriggersHeading.on('click touchstart', function(){
            var gemSectionSelectNumber = $(this).closest('.item-content').attr('data-index');
            // Grabs data-index attribute and updates body attribute
            $('body').attr('data-journey-product',gemSectionSelectNumber);
            //console.log('Product Select: '+ gemSectionSelectNumber);
            // Reset slides - add into array, each resets slide
            var gemSectionProductSelectSliders = [
                '.mosaic-section .mosaic-square.mosaic-slider > div:first-child',
                '.shop-section .product-list > .gf_icon-list',
                '.review-section .slide > div:first-child',
                '.champ-section .champ-slider > .gf_column',
                '.feature-section .feature-slider > .gf_column'
            ];
            // Reset sliders from array above
            $.each( gemSectionProductSelectSliders, function( index, value ) {
                if( $(value).length > 0) {
                    $(value).slick('slickGoTo', 0);
                }
            });
            // Active States
            gemSectionSelectTriggers.find('.item-content.js-active').removeClass('js-active');
            gemSectionSelectTriggers.find('.item-content[data-index='+gemSectionSelectNumber+']').addClass('js-active');
        });
    }
}
gemProductSelect();


/*
(function(){
    //$('h1').css('border','dashed 1px orange');
})();
*/


/**
 * Gem Hero Recon
 * js anchor link emulator
 * Traverses to next gf-row element unless it is the last.
 */
if ($('body:not(.gempage-editing) .gryffeditor .recon-hero-section').length > 0) {
    $('body:not(.gempage-editing) .recon-hero-section').each(function(){
        var gemSectionReconHero             = $(this),
            gemSectionReconHeroAnchor       = gemSectionReconHero.find('.text-anchor > p'),
            gemSectionReconHeroAnchorTarget = $(this).closest('.recon-hero-section').next('.gf_row');
        // Anchor
        if (gemSectionReconHeroAnchor.length > 0) {
            gemSectionReconHeroAnchor.on('click touchstart', function(){
                if (gemSectionReconHeroAnchorTarget.length > 0) {
                    $('html, body').animate({ scrollTop: gemSectionReconHeroAnchorTarget.offset().top }, gemSectionSpeed);
                }
            });
        }
    });
}


/**
 * Gem Quick Start Recon
 * js anchor link emulator
 * Traverses to next gf-row element unless it is the last.
 */
if ($('body:not(.gempage-editing) .gryffeditor .quick-start-anchor').length > 0) {
    $('body:not(.gempage-editing) .quick-start-anchor').each(function(){
        var gemSectionReconText             = $(this),
            gemSectionReconTextAnchor       = gemSectionReconText.find('.text-anchor > h5'),
            gemSectionReconTextAnchorTarget = $(this).closest('.feature-section.recon').next('.gf_row');
        // Anchor
        if (gemSectionReconTextAnchor.length > 0) {
            gemSectionReconTextAnchor.on('click touchstart', function(){
                if (gemSectionReconTextAnchorTarget.length > 0) {
                    $('html, body').animate({ scrollTop: gemSectionReconTextAnchorTarget.offset().top }, gemSectionSpeed);
                }
            });
        }
    });
}


// Calls out to Beachify, which in turns calls the Bronto API
// to check if a user is already registered to a given email list
// before subscribing that user.

async function getBrontoStatus(shop, email, list) {
    let url = 
        'https://beachify.turtlebeach.com/api/services/bronto/lookup?' +
        'shop=' + shop +
        '&email=' + encodeURIComponent(email) +
        '&list=' + list;
    let response = await fetch(url);
    let result = await response.json();
    let data = result.data;
    var subStatus;
    if (!data.status) {
        subStatus = data[0].status;
    } else {
        subStatus = data.status; 
    }
    if (subStatus == 2) {
        return true;
    } else {
        return false;
    }
};
// @DO - Prevents EU & UK customers from reaching checkout until terms & conditions are accepted.

window.addEventListener('load', function() {

  if (document.querySelector('#gdpr-acceptance-modal')) {

    const gdprModal = document.querySelector('#gdpr-acceptance-modal');
    const gdprModalCloseButton = document.querySelector('#gdpr-acceptance-modal .modal-close');
    const gdprModalCheckoutButton = document.querySelector('#modal-checkout-button');
    const minicartCheckoutButtons = document.querySelectorAll('.btn-checkout');
    const cartCheckoutButton = document.querySelector('input[name="checkout"]');
    const cartPageForm = document.querySelector('#shopify-section-cart form');
    const gdprAgree = document.querySelector('#gdpr-agree');
    const gdprCheckoutButtonText = document.querySelector('#checkout-button-text').textContent;
    const gdprButtonDisabledText = gdprModalCheckoutButton.textContent;

    // set up event listeners on minicart buttons
    if (minicartCheckoutButtons.length > 0) {
      for (var i = 0; i < minicartCheckoutButtons.length; i++) {
        minicartCheckoutButtons[i].addEventListener('click', function(evt) {
          showGDPRModal(evt);
        })
      }
    }

    // set up event listener on cart page checkout button
    if (cartCheckoutButton) {
      cartCheckoutButton.addEventListener('click', function(evt) {
        showGDPRModal(evt);
      })
    }

    // set event listener on the checkbox
    if (gdprAgree) {
      gdprAgree.addEventListener('change', function() {
        if (!gdprAgree.checked) {
          disableButton();
        } else {
          gdprModalCheckoutButton.removeAttribute('disabled');
          gdprModalCheckoutButton.textContent = gdprCheckoutButtonText;
        }
      })

    }

    // set event lisetenr on modal's checkout button
    gdprModalCheckoutButton.addEventListener('click', function(evt) {
      openCheckout(evt.target);
    })
    
    //disable modal's checkout button if button not checked
    function disableButton() {
      gdprModalCheckoutButton.setAttribute("disabled", "true");
      gdprModalCheckoutButton.innerText = gdprButtonDisabledText;
    }

    // show the modal, prevent cart button from opening checkout directly
    function showGDPRModal(event) {
      event.preventDefault();
      gdprModal.dataset.show = "true";
      gdprAgree.checked = false;
      disableButton();
    }

    // hide modal when closed
    gdprModalCloseButton.addEventListener('click', () => {
      gdprModal.dataset.show = "false";
    })

    // open checkout when box is checked and button is clicked
    function openCheckout(activator) {
      if (gdprModalCheckoutButton.disabled === false) {
        if (cartPageForm === activator) {
          cartPageForm.submit();
        } else {
          window.open('/checkout', "_self");
        }
      }
    }
  }

})

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Shopify ================*/
/**
 * Shopify Cart APIs
 * ------------------------------------------------------------------------------
 *
 * @namespace cart
 */

shopify.cart = (function() {

  getCart = function(options) {
    if (options == null) {
      options = {};
    }
    options.type = 'GET';
    options.updateCart = true;
    return addQueue('/cart.js', {}, options);
  },

  addItem = function(id, quantity, properties, options) {
    var data;
    if (quantity == null) {
      quantity = 1;
    }
    if (properties == null) {
      properties = {};
    }
    if (options == null) {
      options = {};
    }
    data = wrapKeys(properties);
    data.id = id;
    data.quantity = quantity;
    var result = addQueue('/cart/add.js', data, options);
    getCart();
    return result;
  },

  /**
   * Updates the variant in the cart with the new quantity
   *
   * @param {string} variantId - Variant Id of the cart item to update
   * @param {int} quantity - Quantity to update the cart item to
   */
  updateCart = function(variantId, quantity, options) {
    var cartUpdateData = {};
    if (options == null) {
      options = {};
    }

    cartUpdateData[variantId] = quantity;
    var data = {updates: cartUpdateData};
    var result = addQueue('/cart/update.js', data, options);
    getCart();
    return result;
  },

  clearCart = function (callback) {
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function () {
        if ( callback && typeof callback === "function" ) {
          callback();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        console.log("Error clearing cart: ", textStatus);
      }
    });
  }

  queue = [];

  processing = false;

  addQueue = function(url, data, options) {
    var request;
    if (options == null) {
      options = {};
    }
    request = {
      url: url,
      data: data,
      type: options.type || 'POST',
      dataType: options.dataType || 'json',
      success: ensureArray(options.success),
      error: ensureArray(options.error),
      complete: ensureArray(options.complete)
    };
    queue.push(request);
    if (processing) {
      return;
    }
    $(document).trigger('cart.requestStarted');
    return processQueue();
  },

  processQueue = function(result) {
    var params;
    if (!queue.length) {
      processing = false;
      $(document).trigger('cart.requestComplete', result);
      return;
    }
    processing = true;
    params = queue.shift();
    var callback = params.complete;
    params.complete = processQueue;

    return $.ajax(params).always(callback);
  },

  wrapKeys = function(obj, type, override) {
    var key, value, wrapped;
    if (type == null) {
      type = 'properties';
    }
    wrapped = {};
    for (key in obj) {
      value = obj[key];
      wrapped["" + type + "[" + key + "]"] = override != null ? override : value;
    }
    return wrapped;
  },

  unwrapKeys = function(obj, type, override) {
    var key, unwrapped, unwrappedKey, value;
    if (type == null) {
      type = 'properties';
    }
    unwrapped = {};
    for (key in obj) {
      value = obj[key];
      unwrappedKey = key.replace("" + type + "[", "").replace("]", "");
      unwrapped[unwrappedKey] = override != null ? override : value;
    }
    return unwrapped;
  },

  isArray = Array.isArray || function(value) {
    return {}.toString.call(value) === '[object Array]';
  },

  ensureArray =  function(value) {
    if (isArray(value)) {
      return value;
    }
    if (value != null) {
      return [value];
    } else {
      return [];
    }
  }

  return  {
    getCart : getCart,
    addItem : addItem,
    updateCart : updateCart,
    clearCart: clearCart
  }
})();
/**
 * Shopify Collection APIs
 * ------------------------------------------------------------------------------
 *
 * @namespace collection
 */

shopify.collection = (function() {
  var COLLECTIONPATH = window.location.pathname + "?view=json&";

  /**
   * Gets a list of products with their attributes given the collection handle.
   * The API that is called returns an HTML div element that contains a JSON string.
   * The caller should extract the value out of the div and convert it to JSON.
   * 
   * This function is dependent on: 
   * templates/collection.json.liquid, sections/collection.liquid, snippets/collection-json.liquid
   * The data is dependent on the section because there are metafield keys that need to be obtained from the section in order to get some values.
   * This causes Shopify to wrap the results automatically in a section div. This is why the api call returns the JSON string inside a div.
   *
   * @param {string} handle - handle of the collection
   * @param {int} page - The page to be retrieved from the paged set of products in the collection - default: 1
   * @param {int} sortBy - Options: manual, best-selling, title-ascending, title-descending, price-ascending, price-descending, created-ascending, created-descending 
   */
  getProducts = function(handle, page, sortBy) {
    var params = {
      sort_by: sortBy ? sortBy : "manual",
      page: page ? page.toString() : "1"
    }
    var urlStr = COLLECTIONPATH + $.param(params);
    return $.get(urlStr);
  }

  return  {
    getProducts : getProducts
  }
})();

/*================ ViewModels ================*/
osvm.collection = function(settings) {
    if (settings == null) {
        settings = {};
  }
  var self = this;
  self.pagination = ko.observable();
  self.products = ko.observableArray([]);           //All products from the collection
  self.filteredProducts = ko.observableArray([]);   //Products filtered by tags
  self.productsPerPage = ko.observable(3);
  self.page = ko.observable(0);
  self.totalProducts = ko.observable(0);
  self.loading = ko.observable(false);
  self.sortByValue = ko.observable();

  var JSONPATH = window.location.pathname + "?view=json&";
  var handle = '';
  var serverPage = 0;
  var currentTags = [];
  var currentAndTags = [];
  var currentOrTags = [];
  var currentPlatform = [];
  var currentConnection = [];
  var currentCategory = [];
  var currentPrice = [];
  var jsonData = {};
  var interactedWithFilter = false;
  var filterCheckBoxes = '.filter-checkbox input';
  var sortByDropdown = '#sort-by';

  self.init = function(handle, sortBy, pagesToLoad, tags, platformTags, connectionTags, categoryTags, priceTags) {
    //Uncheck all filter checkboxes on load
    $(filterCheckBoxes).each(function( index ) {
      $(this).attr('checked', false);
    });

    self.handle = handle;
    self.sortByValue(sortBy);
    return self.load(pagesToLoad, tags, platformTags, connectionTags, categoryTags, priceTags, sortBy);
  }

  self.load = function(pagesToLoad, tags, platformTags, connectionTags, categoryTags, priceTags, sortBy) {
    self.loading(true);
    var maxProducts = (pagesToLoad + self.page()) * self.productsPerPage();

    // exit condition for recursive call or exit if we got enough filteredProducts already
    if (allPagesRetrieved(serverPage) || self.filteredProducts().length >= maxProducts){
      self.page(serverPage);
      self.loading(false);
      return $.Deferred().resolve().promise();
    }

    serverPage += 1;
    disableFilters();

    var result = shopify.collection.getProducts(handle, serverPage, sortBy);
    return result
      .done(function(data){
        jsonData = JSON.parse($($.parseHTML(data)).text());

        // console.log(jsonData);

        self.pagination = ko.mapping.fromJS(jsonData.collection.pagination);
        self.totalProducts(self.pagination.total());

        ko.utils.arrayForEach(jsonData.collection.products, function (product){
          product.addingToCart = ko.observable(false);
          product.error = ko.observable('false');
          self.products.push(product);
          if (tags === undefined || tags.length === 0) {
            self.filteredProducts.push(product);
          } else {
            var canAddPlatform = false;
            var canAddConnection = false;
            var canAddCategory = false;
            var canAddPrice = false;

  
              ko.utils.arrayForEach(product.tags, function (tag) {
                    if (platformTags.length <= 0) {
                        canAddPlatform = true;
                    } else {
                        for (var index = 0; index < platformTags.length; index++) {
                            if (platformTags[index].toLowerCase() == tag.toLowerCase()) {
                                canAddPlatform = true;
                                break;
                            }
                        }
                    }
                    if (connectionTags.length <= 0) {
                        canAddConnection = true;
                    } else {
                        for (var index = 0; index < connectionTags.length; index++) {
                            if (connectionTags[index].toLowerCase() == tag.toLowerCase()) {
                                canAddConnection = true;
                                break;
                            }
                        }
                    }
                    if (categoryTags.length <= 0) {
                        canAddCategory = true;
                    } else {
                        for (var index = 0; index < categoryTags.length; index++) {
                            if (categoryTags[index].toLowerCase() == tag.toLowerCase()) {
                                canAddCategory = true;
                                break;
                            }
                        }
                    }
                    if (priceTags.length <= 0) {
                      canAddPrice = true;
                    } else {
                      for (var index = 0; index < priceTags.length; index++) {
                          if (priceTags[index].toLowerCase() == tag.toLowerCase()) {
                              canAddPrice = true;
                              break;
                          }
                      }
                    }
              });
              if (canAddPlatform === true && canAddConnection === true && canAddCategory === true && canAddPrice === true) {
                  self.filteredProducts.push(product);
  
              }
          }
        })
      })
      .then(function() {
        enableFilters();
        // recursive AJAX call
        return self.load(pagesToLoad, tags, platformTags, connectionTags, categoryTags, priceTags, self.sortByValue())
      })
  }

  self.filter = function(tags, platformTags, connectionTags, categoryTags, priceTags) {
    //Prevents us from double loading more products while another load is in progress
    if(self.loading() == true) {
      return;
    }
    var maxProducts = self.productsPerPage();
    //reset the filtered products
    self.filteredProducts([]);
    currentTags = tags;
    // currentAndTags = andTags;
    // currentOrTags = orTags;
    currentPlatform = platformTags;
    currentConnection = connectionTags;
    currentCategory = categoryTags;
    currentPrice = priceTags;

    //if no tags, just used the main product list here
    if (tags === undefined || tags.length === 0) {
      self.filteredProducts(self.products());
    }
    else {

      for (var i = 0; i < self.products().length; i++) {
          var product = self.products()[i];
          var canAddPlatform = false;
          var canAddConnection = false;
          var canAddCategory = false;
          var canAddPrice = false;

            ko.utils.arrayForEach(product.tags, function (tag) {
                  if (platformTags.length <= 0) {
                      canAddPlatform = true;
                  } else {
                      for (var index = 0; index < platformTags.length; index++) {
                          if (platformTags[index].toLowerCase() == tag.toLowerCase()) {
                              canAddPlatform = true;
                              break;
                          }
                      }
                  }
                  if (connectionTags.length <= 0) {
                      canAddConnection = true;
                  } else {
                      for (var index = 0; index < connectionTags.length; index++) {
                          if (connectionTags[index].toLowerCase() == tag.toLowerCase()) {
                              canAddConnection = true;
                              break;
                          }
                      }
                  }
                  if (categoryTags.length <= 0) {
                      canAddCategory = true;
                  } else {
                      for (var index = 0; index < categoryTags.length; index++) {
                          if (categoryTags[index].toLowerCase() == tag.toLowerCase()) {
                              canAddCategory = true;
                              break;
                          }
                      }
                  }
                  if (priceTags.length <= 0) {
                    canAddPrice = true;
                  } else {
                    for (var index = 0; index < priceTags.length; index++) {
                        if (priceTags[index].toLowerCase() == tag.toLowerCase()) {
                            canAddPrice = true;
                            break;
                        }
                    }
                  }
            });
            if (canAddPlatform === true && canAddConnection === true && canAddCategory === true && canAddPrice === true) {
                self.filteredProducts.push(product);
            }
      }
    }
    //try and load more if necessary
    var pageTotal = jsonData.collection.pagination.pages;
    if (!interactedWithFilter) {
      self.load(pageTotal, tags, platformTags, connectionTags, categoryTags, priceTags, self.sortByValue());
    }

    if (self.filteredProducts().length < maxProducts && !self.loading() && interactedWithFilter == true) {
      self.load(pageTotal, tags, platformTags, connectionTags, categoryTags, priceTags, self.sortByValue());
    }

    interactedWithFilter = true;
  }

  self.viewall = function() {
    var pageTotal = jsonData.collection.pagination.pages;

    if(!interactedWithFilter) {
      self.load(pageTotal, [], [], [], [], [], self.sortByValue());
    } else {
      self.filter([], [], [], [], []);
    }
  }

  self.sortBy = function(sortByVal) {
    //reset the filtered products
    self.filteredProducts([]);
    self.products([]);
    serverPage = 0;
    self.page(0);
    self.sortByValue(sortByVal);

    var pageTotal = jsonData.collection.pagination.pages;

    self.load(pageTotal, currentTags, currentPlatform, currentConnection, currentCategory, currentPrice, sortByVal);
  }

  self.loadNextPage = function() {
    if (!allPagesRetrieved(serverPage)) {
      return self.load(1, currentPlatform, currentConnection, currentCategory, currentPrice, self.sortByValue());
    }
  }

  self.hasMoreProducts = function() {
    return !allPagesRetrieved(serverPage);
  }

  self.compareProduct = function(product) {
    theme.CompareModal.addCompareProduct( product.handle );
  }

  self.addToCart = function(product) {
    if ( product.variants.length > 1 ) {
      window.location = product.url;
      return false;
    }

    var variantId = product.selectedOrFirstVariantId;
    var quantity = 1;
    var properties = {};
    var options = {};
    var cartEmpty = false;
    var cartHasPreorder = false;
    var cartHasSamePreorder = false;
    var oneItemInCart = false;

    var item = {
      "id": product.id,
      "title": product.title,
      "sku": product.selectedOrFirstVariantSku,
      "price": Number(product.price.replace(/\D/g,'')),
      "compare_at_price": Number(product.compareAtPrice.replace(/\D/g,'')),
      "option1": product.option1,
      "option2": product.option2,
      "barcode": product.barcode
    };

    options.error = function() {
      product.error('true');
      product.addingToCart(false);
    };

    options.success = function() {
      product.addingToCart(false);
      modules.tealium.addToCart(item, quantity);
      theme.minicart.slideout();
    };

    if ( product.preorderShipDate ) {
      properties.preorderShipDate = product.preorderShipDate;
    }

    if ( product.preorderEnabled ) {
      $.ajax({
        url: "/cart",
        async: false,
        dataType: "json",
        success: function (cart) {
          if ( cart.items.length == 0 ) {
            cartEmpty = true;
          }

          if ( cart.items.length == 1 ) {
            oneItemInCart = true;
          }

          cart.items.forEach(function (item) {
            if ( item.properties.preorderShipDate ) {
              cartHasPreorder = true;
            }

            if ( item.variant_id == variantId ) {
              cartHasSamePreorder = true;
            }
          });
        }
      });

      if ( product.preorder && cartEmpty ) {
        product.addingToCart(true);
        addDirectlyToCart(variantId, properties);
        return;
      }

      if ( product.preorder && oneItemInCart && cartHasSamePreorder ) {
        product.addingToCart(true);
        addDirectlyToCart(variantId, properties);
        return;
      }

      if ( product.preorder || cartHasPreorder ) {
        theme.preorderModal.show(variantId, quantity, product.preorderShipDate);
        return;
      }
    }

    product.addingToCart(true);

    if (product.bundleItems.length > 0) {
      ko.utils.arrayForEach(product.bundleItems, function (bundleItem){
        shopify.cart.addItem(bundleItem, quantity, properties, options);
      });
    } else {
      shopify.cart.addItem(variantId, quantity, properties, options);
    }
  }

  var paginationHasValue = function() {
    return ko.utils.unwrapObservable(self.pagination)  != undefined
  }

  var productsHasValue = function() {
    return ko.utils.unwrapObservable(self.products)  != undefined
  }

  var allPagesRetrieved = function(page) {
    return paginationHasValue() && page >= parseInt(self.pagination.pages());
  }

  var disableFilters = function() {
    $(filterCheckBoxes).each(function( index ) {
      $(this).attr("disabled", true);
    });
    $(sortByDropdown).attr("disabled", true);
  }

  var enableFilters = function() {
    $(filterCheckBoxes).each(function( index ) {
      $(this).removeAttr("disabled");
    });
    $(sortByDropdown).removeAttr("disabled");
  }

  function addDirectlyToCart(id, properties) {
    $.ajax({
      url: "/cart/add.js",
      type: "post",
      data: { id: id, quantity: 1, properties: properties }
    }).always(function () {
      window.location = "/cart";
    });
  }
}

osvm.cart = function(settings) {
    if (settings == null) {
        settings = {};
  }
  var self = this;
  self.items = ko.observableArray([]);
  self.subTotal = ko.observable();
  self.discount = ko.observable(0);
  self.discountMoney = ko.observable();
  self.loading = ko.observable(false);
  self.itemCount = ko.observable(0);
  self.showQuantityMessage = ko.observable(false);

  self.showQuantityMessage = ko.computed(function() {
    var maxValue = Math.max.apply(Math, this.items().map(function(obj){return obj.quantity;}));
    return theme.quantityLimit === -1 ? false : maxValue > theme.quantityLimit;
  }, this);

  self.init = function() {
    $(document).on('cart.requestComplete', function(evt, data) {
      self.loadCart(evt, data);
    });

    //get the inital cart data
    shopify.cart.getCart();
  };
  
  self.loadCart = function(evt, data) {
    if (!data) return;

    var response = data.responseJSON;
    if (response && response.items) {
      self.items(response.items);
      self.itemCount(response.item_count);
      self.discount(response.total_discount);
      var discount = slate.Currency.formatMoney(response.total_discount, theme.moneyFormat)
      self.discountMoney(discount);
      var subTotal = slate.Currency.formatMoney(response.total_price, theme.moneyFormat)
      self.subTotal(subTotal);
    }
  };

  self.removeItem = function(variantId) {
    var product = self.items().find(function(item) {
      return item.id === variantId;
    });
    var item = {
          "id": product.product_id,
          "title": product.product_title,
          "sku": product.sku,
          "price": product.line_price,
          "compare_at_price": product.price,
          "variant_options": product.variant_options,
          "quantity": product.quantity
        };

    modules.tealium.removeCartItem(item);
  };
}

/*================ Theme ================*/
/**
 * Theme minicart
 * ------------------------------------------------------------------------------
 *
 * @namespace minicart
 */

theme.minicart = (function() {

  /**
   * slides minicart out
   *
  */

  slideout= function () {
    //display the mini cart
    var $miniCartOverlay = $("[data-cart-mini-overlay]");
    var $miniCart = $("[data-cart-mini]");
    if ($miniCart.hasClass("hide")) {
        $('body').addClass('no-scroll');
        $miniCartOverlay.removeClass("hide-overlay");
        $miniCart.removeClass("hide").addClass("fadeInRight");
    }
  }

  return  {
    slideout : slideout
  }
})();
theme.preorderModal = (function () {

  var elements = {
    overlay: document.getElementById("preorder-modal"),
    continueButton: document.querySelector("[data-preorder-modal-continue-button]"),
    $continueButton: $("[data-preorder-modal-continue-button]"),
    cancelButton: document.querySelector("[data-preorder-modal-cancel-button]"),
    closeButton: document.querySelector("[data-preorder-modal-close-button]"),
    $form: $("[data-preorder-modal-form]"),
    id: document.querySelector("[data-preorder-form-id]"),
    quantity: document.querySelector("[data-preorder-form-quantity]"),
    $shipDate: $("[data-preorder-form-ship-date]")
  };

  if ( !elements.overlay ) {
    return false;
  }

  elements.closeButton.addEventListener("click", hide);

  elements.cancelButton.addEventListener("click", hide);

  elements.continueButton.addEventListener("click", function (event) {
    event.preventDefault();

    elements.continueButton.setAttribute("disabled", true);

    shopify.cart.clearCart(function () {
      elements.$form.submit();
    });
  });

  function show(id, quantity, date) {
    elements.id.setAttribute("value", id);
    elements.quantity.setAttribute("value", quantity);
    elements.$shipDate.attr("value", date);
    elements.overlay.setAttribute("data-show-modal", "true");
  }

  function hide() {
    elements.overlay.setAttribute("data-show-modal", "false");
  }

  return {
    show: show,
    hide: hide
  }
})();
theme.featuredCollection = (function () {
  var liquid = document.getElementById("liquid-json").innerHTML,
      liquid = JSON.parse(liquid);

  if ( liquid.template.name == "product" ) {
    return false;
  }

  var quantity = 1;

  var options = {
    success: function () {
      theme.minicart.slideout();
    }
  };

  var elements = {
    $addToCart: $('[data-add-to-cart]'),
    $addToCartBundle: $('[data-add-bundle-to-cart]'),
    $compareIcon: $('.compare-icon')
  };

  elements.$addToCart.on("click", function (event) {
    event.preventDefault();

    var $this = $(this);
    var $form = $this.closest("form");

    if ( !$form ) {
      event.preventDefault();
      return;
    }

    var $variant = $form.find('[data-product-select]');

    if ( !$variant ) {
      event.preventDefault();
      return;
    }

    var properties = {};
    var variantId = $variant.val();
    var preorderEnabled = this.hasAttribute("data-preorder-enabled");
    var preorderShipDate = this.getAttribute('data-preorder-date') || "";
    var preorderButton = this.hasAttribute('data-preorder');
    var cartEmpty = false;
    var oneItemInCart = false;
    var cartHasPreorder = false;
    var cartHasSamePreorder = false;

    if ( preorderEnabled ) {
      $.ajax({
        url: "/cart",
        async: false,
        dataType: "json",
        success: function (cart) {
          if ( cart.items.length == 0 ) {
            cartEmpty = true;
          }

          if ( cart.items.length == 1 ) {
            oneItemInCart = true;
          }

          cart.items.forEach(function (item) {
            if ( item.properties.preorderShipDate ) {
              cartHasPreorder = true;
            }

            if ( item.variant_id == variantId ) {
              cartHasSamePreorder = true;
            }
          });
        }
      });

      if ( preorderButton && cartEmpty ) {
        $form.submit();
        return true;
      }

      if ( preorderButton && oneItemInCart && cartHasSamePreorder ) {
        $form.submit();
        return true;
      }

      if ( preorderButton || cartHasPreorder ) {
        theme.preorderModal.show(variantId, quantity, preorderShipDate);
        return;
      }
    }

    options.error = function () {
      $this.text(theme.strings.unavailable);
      $this.prop('disabled', true);
    }

    event.preventDefault();

    shopify.cart.addItem(variantId, quantity, properties, options);
  });

  elements.$addToCartBundle.on('click', function(event) {
    event.preventDefault();

    var $this = $(this);
    var $form = $this.closest("form");

    if (!$form) return;

    var $bundleItems = $form.find('[data-product-bundle-select] > option');

    if (!$bundleItems) return;

    options.error = function() {
      $this.html(theme.strings.unavailable);
      $this.prop('disabled', true);
    }

    $bundleItems.each(function(index){
      var variantId = $(this).val();
      shopify.cart.addItem(variantId, quantity, {}, options);
    });
  })

  elements.$compareIcon.on("click", function (event) {
    event.preventDefault();
    var productHandle = $(this).attr("data-compare-info");
    theme.CompareModal.addCompareProduct( productHandle );
  });

})();

window.addEventListener('load', () => {
  // TBCIP-1623 - Pages - Stealth, Slide Change Button Not Labeled
  const sliderDots = document.querySelectorAll('.gf_row .gf_tab-panel .owl-carousel .owl-dots');

  if (sliderDots.length > 0) {
    sliderDots.forEach((dotContainer) => {
      const owlDots = dotContainer.querySelectorAll('button.owl-dot');

      owlDots.forEach(function(dot, index) {
        let slideNumber = index + 1;
        dot.setAttribute('aria-label', 'Slide ' + slideNumber);
      });
    });
  }

  // TBCIP-1624 - Pages - Stealth, "Close" not Labeled
  const popupButtons = document.querySelectorAll('.module .video-popup');

  if (sliderDots.length > 0) {
    popupButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        addAriaLabelToCloseButton();
      });
    });
  }

  addAriaLabelToCloseButton();

  // TBCIP-1621 - Pages - Control Studio, Cannot Navigate Using Keyboard
  const tabLists = document.querySelectorAll('.gf_row .gf_restabs ul');
  if (tabLists.length > 0) {
    tabLists.forEach((list) => {
      list.setAttribute('role', 'tablist');
    });
  }

  const tabs = document.querySelectorAll('.gf_row .gf_restabs li.gf_tab');
  if (tabs.length > 0) {
    tabs.forEach((tab) => {
      const isActive = tab.classList.contains('gf_tab-active');
      tab.setAttribute('role', 'tab');
      tab.setAttribute('tabindex', '0');
      tab.setAttribute('aria-selected', isActive.toString());
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          tab.click(); // Simulate a click when Enter is pressed

          tabs.forEach((t) => t.setAttribute('aria-selected', 'false'));
          // Set aria-selected to true for the clicked tab
          tab.setAttribute('aria-selected', 'true');
        }
      });
    });
  }
});

function addAriaLabelToCloseButton() {
  // Add Close attribute for GEM modal close button
  const closeButton = $('button.mfp-close');
  // Check if the button was found
  if (closeButton.length > 0) {
    // Add the aria-label attribute
    closeButton.attr('aria-label', 'Close');
  }
}

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('cart', theme.Cart);
  sections.register('slideshow', theme.Slideshow);
  sections.register('header-top-bar', theme.HeaderTopBar);
  sections.register('header', theme.Header);
  sections.register('product-content', theme.ProductContent);
  sections.register('collection-top-bar-sort', theme.CollectionTopBarSort);
  sections.register('collection', theme.Collection);
  sections.register('collection-filter-dropdown', theme.CollectionFilterDropdown);
  sections.register('product-information', theme.ProductInformation);
  sections.register('back-to-top', theme.BackToTop);
  sections.register('newslettermodal', theme.NewsletterModal);
  sections.register('cookies-modal', theme.CookiesModal);
	sections.register('back-in-stock-modal', theme.BackInStockModal);
  sections.register('content-products', theme.ContentProducts);
  sections.register('content-yotpo', theme.ContentYotpo);
  sections.register('footer', theme.Footer);
  sections.register('shopping-guide', theme.ShoppingGuide);
  sections.register('do-gem-custom', theme.DoGemCustom);
	sections.register('compare-modal', theme.CompareModal);
	sections.register('get-bronto-status', theme.GetBrontoStatus);
	sections.register('gdpr-checkbox-modal', theme.GDPRCheckboxModal);

  //initialize the cart VM
  theme.cartVM.init();

  var miniCartElements = $("[data-cart-mini]");

  if (miniCartElements) {
    $.each(miniCartElements, function(i,element) {
      ko.applyBindings(theme.cartVM, element);
    })
  }
  $("[data-cart-item-count]").each(function() {
    ko.applyBindings(theme.cartVM, this);
  })

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // COMPARE : Initialize Compare Feature ($ returns obj always)
  var compareModalEnabled = document.getElementById( 'compare-modal-parent' ); // Null if disabled
  if ( compareModalEnabled && theme.CompareModal ) theme.CompareModal.init();

  var customerPosted = '?customer_posted=true';
  var urlSearchParam = window.location.search;

  if(urlSearchParam.indexOf(customerPosted) !== -1) {
    $('html,body').animate({
        scrollTop: $('footer').offset().top
        },'slow');
  }

});



/* --------------------------------------------------------------------------
HPR youtube API video initializer
-----------------------------------------------------------------------------
*/

// Setting up mosaic video square responsive sizes after document load
var videoWidth = $('.video-square').width();
$("#mosaicplayer").data('video-width', videoWidth);
$("#mosaicplayer").data('video-height', videoWidth);

// Loading iframe API Script
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// Gets all existing youtube API players into an array. Use .hpr-youtube-player in your element to include it here.
var videoPlayers = $.map($(".hpr-youtube-player"), function(n, i){
  return {
	  playerid: n.id,
	  width: $(n).data("video-width"),
	  height:$(n).data("video-height"),
	  videoid: $(n).data("video-id"),
	  autoplay: $(n).data("autoplay"),
	  loop: $(n).data("loop")
	};
});

// Sets custom eventHandlers for all players
videoPlayers.forEach(function (player) {

	if (player.playerid == "heroplayer"){
		player.events = {
			'onReady': onHeroPlayerReady,
			'onStateChange': onHeroPlayerStateChange
		}
	}
	else if (player.playerid == "mosaicplayer") {
		player.events = {
			'onReady': onMosaicPlayerReady,
			'onStateChange': onMosaicPlayerStateChange
		}
	}
	else {
		player.events = {
			'onReady': onPlayerReady,
			'onStateChange': onPlayerStateChange
		}
	}
  });

// Initializes youtube players
function createPlayer(videoPlayer) {
	return new YT.Player(videoPlayer.playerid, {
		height: videoPlayer.height,
		width: videoPlayer.width,
		videoId: videoPlayer.videoid,
		controls: '0',
		playerVars: {
			autoplay: videoPlayer.autoplay,
			loop: videoPlayer.loop
		},
		events: videoPlayer.events
	});
}

var players = new Array();

function onYouTubePlayerAPIReady() {
	if (typeof videoPlayers === 'undefined')  {
		return;
	}
	for (var i = 0; i < videoPlayers.length; i++) {
		var curplayer = createPlayer(videoPlayers[i]);
		players[i] = curplayer;
	}
}

//Hero EventHandlers
function onHeroPlayerReady(event) {
	if (event.target.h.id == "heroplayer") {
		// console.log("hero player loaded");
		var playButtonHero = document.getElementById("hero-overlay-play");
		playButtonHero.addEventListener("click", function(e) {
			$(".hero-player-overlay").hide();
			if($(document).width() < 750) {
				$(".hero-player-pause-overlay").addClass("active");
			}
			$("#hero-video").show();
			event.target.mute();
			event.target.playVideo();
		});
	}
}

function onHeroPlayerStateChange(event) {
	if (event.target.h.id == "heroplayer") {
		if (event.data === YT.PlayerState.PLAYING) {
			if($(document).width() > 750) {
				$('.hero-player-pause-overlay').removeClass('active');
			}
		}
		if(event.data === YT.PlayerState.PAUSED ) {
			$('.hero-player-pause-overlay').addClass('active');
		}
		if (event.data === YT.PlayerState.ENDED) {
			$('.hero-player-pause-overlay').removeClass('active');
			$("#hero-video").hide();
			$('.hero-player-overlay').show();
		}
	}
}

//Mosaic EventHandlers
function onMosaicPlayerReady(event) {
	if (event.target.h.id == "mosaicplayer") {
		var playButtonMosaic = document.getElementById("mosaic-overlay-play");

		playButtonMosaic.addEventListener("click", function() {
				event.target.playVideo();
				$('#video-cta').removeClass('active');
				$('.video-player-overlay').hide();
		});
	}
}
function onMosaicPlayerStateChange(event) {
	if (event.target.h.id == "mosaicplayer") {
		if (event.data === YT.PlayerState.PLAYING) {
			// Updates container styles for video-watching
			$('.video-square').addClass('playing');
			$('iframe#mosaicplayer').addClass('playing');
			$('.video-player-overlay').hide();
			//Slowly removes pause CTA on desktop screens - this should cover youtube related video suggestions
			if($(document).width() > 1024) {
				$("#video-cta").fadeOut("slow", function() {
					$(this).removeClass("paused");
				});
			}
		}
		if(event.data === YT.PlayerState.PAUSED ) {
			$('#video-cta').addClass('paused');
		}
		if (event.data === YT.PlayerState.ENDED) {
			// Removes any style from other states
			$('.video-square').removeClass('playing');
			$('iframe#mosaicplayer').removeClass('playing');
			$('#video-cta').removeClass('paused');
			// Displays default overlays
			$('#video-cta').addClass('active');
			$('.video-player-overlay').show();
		}
	}
}

//Default EventHandlers
function onPlayerReady(event) {
}

function onPlayerStateChange(event) {
	if (event.data === YT.PlayerState.PLAYING) {
	}

	if(event.data === YT.PlayerState.PAUSED ) {
	}

	if (event.data === YT.PlayerState.ENDED) {
	}
}

//Remove 'Hidden' from page title
$('#MainContent > h1').text(function(){
  return $(this).text().replace("[hidden]", "");
});

/// Redirects user back to checkout page after they have successfully signed in or registered via the 'Log In/Create an Account' button
if (window.location.href.indexOf("?checkout-login") > -1) {
  //set checkout url local object so if user wants to create an account they will still be redirected after they submit form
  localStorage.setItem('checkout-url', '/checkout');
  // set path to redirect after form submission
  $('#customer_login [name="return_to"]').val('/checkout');
}
else {
    //if registration page
    if ($('#create_customer').length > 0) {
        //if local storage has checkout url
        if (localStorage.getItem('checkout-url')) {
            // change action on form to redirect to checkout page
            $('#RegisterForm [name="return_to"]').val(localStorage.getItem('checkout-url')); //set product url to return_to input
        }
    }
    //if captcha page, still do redirect
    else if ($('#g-recaptcha').length) {
        console.log("captcha page");
        if (localStorage.getItem('checkout-url')) {
            var $newInput = $('<input type="hidden" name="return_to" value="' + localStorage.getItem('checkout-url') + '" />');
            $newInput.insertBefore($('.shopify-challenge__container input[type="submit"]'));
        }
    } else {
        //else remove checkout url from local storage
        localStorage.removeItem('checkout-url');
    }
}
 $('.modal-close').on('click', function(e) {
    e.preventDefault();
    $('.modal').removeClass('is-visible');
 });

// klaviyo accessibility(ARIA)
var klaviyoStartTime = new Date().getTime();
var klaviyoRenderCheck = setInterval(function(){
    if(new Date().getTime() - klaviyoStartTime > 60000){
        clearInterval(klaviyoRenderCheck);
        return;
    }
    if (document.querySelector('.klaviyo-form')) {
		$('.klaviyo-form img').attr('alt', 'turtle beach');
		$('.klaviyo-form input[type="checkbox"]').attr('aria-describedby', $('.klaviyo-form input[type="checkbox"]').attr('id'));
		$('.klaviyo-form div[role="group"]').attr('aria-labelledby', $('.klaviyo-form div[role="group"] > label').attr('for'));
		clearInterval(klaviyoRenderCheck);
	}
}, 1000);
